export const articlesBasics = [
  {
    slug: 'what-is-forex',
    category: 'Forex พื้นฐาน',
    categorySlug: 'forex-basics',
    title: 'Forex คืออะไร? คู่มือทำความเข้าใจตลาดแลกเปลี่ยนเงินตราสำหรับมือใหม่',
    description:
      'ทำความรู้จัก Forex คืออะไร ซื้อขายกันอย่างไร ใครอยู่ในตลาดนี้บ้าง และทำไมตลาดถึงเปิดตลอด 24 ชั่วโมง',
    readingTime: '8 นาที',
    updatedDate: '2026-09-18',
    level: 'มือใหม่',
    heroImage:
      'https://public.readdy.ai/ai/img_res/edited_d1f87988801c6497198622ba727a22f4_0a7a997d.jpg',
    tags: ['Forex', 'พื้นฐาน', 'มือใหม่'],
    intro: [
      'Forex ย่อมาจาก Foreign Exchange หมายถึงตลาดแลกเปลี่ยนเงินตราต่างประเทศ ซึ่งเป็นตลาดการเงินที่ใหญ่ที่สุดในโลก ด้วยมูลค่าการซื้อขายต่อวันสูงถึงหลายล้านล้านดอลลาร์',
      'บทความนี้จะพาคุณมือใหม่ทำความเข้าใจว่า Forex คืออะไร ซื้อขายกันอย่างไร และควรเริ่มต้นเรียนรู้จากตรงไหน',
    ],
    sections: [
      {
        id: 'forex-meaning',
        heading: 'Forex คืออะไร',
        paragraphs: [
          'Forex คือการซื้อสกุลเงินหนึ่งพร้อมขายอีกสกุลเงินหนึ่งพร้อมกันในรูปแบบคู่เงิน (Currency Pair) เช่น EUR/USD คือการเทียบมูลค่าระหว่างยูโรกับดอลลาร์สหรัฐ',
          'เมื่อเราซื้อ EUR/USD หมายความว่าเราคาดว่ายูโรจะแข็งค่าขึ้นเมื่อเทียบกับดอลลาร์ และกลับกันเมื่อเราขาย',
        ],
        bullets: [
          'เป็นการเทรดคู่เงินเสมอ ไม่ใช่ซื้อสกุลเงินเดี่ยว',
          'ทำกำไรจากส่วนต่างของราคา ไม่ได้ถือสกุลเงินจริง',
          'ตลาดเปิด 24 ชั่วโมง 5 วันต่อสัปดาห์',
        ],
        steps: [],
      },
      {
        id: 'how-market-works',
        heading: 'ตลาด Forex ทำงานอย่างไร',
        paragraphs: [
          'ตลาด Forex ไม่มีศูนย์กลางการซื้อขายที่เดียว แต่เป็นการซื้อขายผ่านเครือข่ายของธนาคารและโบรกเกอร์ทั่วโลก (OTC Market) ราคาจึงถูกกำหนดจากอุปสงค์และอุปทานของทั้งตลาด',
          'ตลาดจะเปิดเป็นรอบตามช่วงเวลาของแต่ละภูมิภาค เริ่มจากซิดนีย์ โตเกียว ลอนดอน และนิวยอร์ก ทำให้มีสภาพคล่องสูงเกือบตลอดเวลา',
        ],
        bullets: [
          'ช่วงที่สภาพคล่องสูงที่สุดคือคาบเกี่ยวระหว่างลอนดอนกับนิวยอร์ก',
          'ราคาเคลื่อนไหวตลอดเวลาแม้ไม่มีข่าวสำคัญ',
          'ค่าเงินได้รับผลกระทบจากดอกเบี้ย เงินเฟ้อ เศรษฐกิจ และข่าวการเมือง',
        ],
        steps: [],
      },
      {
        id: 'market-players',
        heading: 'ใครบ้างที่อยู่ในตลาด Forex',
        paragraphs: [
          'ผู้เล่นในตลาด Forex มีหลายกลุ่มต่างกัน ทั้งที่มีวัตถุประสงค์เพื่อป้องกันความเสี่ยงและเพื่อทำกำไรจากการคาดการณ์ราคา',
        ],
        bullets: [
          'ธนาคารกลางและธนาคารพาณิชย์ขนาดใหญ่',
          'บริษัทที่ต้องซื้อขายเงินตราระหว่างประเทศ',
          'กองทุนและนักลงทุนสถาบัน',
          'เทรดเดอร์รายย่อยอย่างเรา ๆ',
        ],
        steps: [],
      },
      {
        id: 'why-learn',
        heading: 'ทำไมมือใหม่ต้องเข้าใจพื้นฐานก่อน',
        paragraphs: [
          'ตลาด Forex มี Leverage ที่ช่วยขยายขนาดการลงทุน แต่ก็ขยายความเสี่ยงเช่นกัน การเข้าใจพื้นฐานอย่างคู่เงิน Pip Spread และ Margin จะช่วยให้คุณวางแผนและควบคุมความเสี่ยงได้ตั้งแต่เริ่มต้น',
          'ลองคิดเป็นตัวเลขง่าย ๆ ด้วย Leverage 1:100 เงินในพอร์ต 100 ดอลลาร์สามารถเปิดสถานะได้ถึง 10,000 ดอลลาร์ ถ้าราคา EURUSD ขยับ 1% จาก 1.0850 ไป 1.0959 ผลกำไรหรือขาดทุนคือ 100 ดอลลาร์ ซึ่งเท่ากับเงินทั้งพอร์ตพอดี คนที่เริ่มโดยไม่รู้เรื่อง Pip กับ Lot จึงมักเปิดไม้ใหญ่เกินไปในออเดอร์แรก ๆ',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ต้องใช้เงินทุนเท่าไหร่จึงเริ่มเทรด Forex ได้',
        a: 'โบรกเกอร์หลายแห่งเปิดบัญชีขั้นต่ำตั้งแต่ 10-100 ดอลลาร์ แต่ตัวเลขนั้นไม่ใช่เกณฑ์จริง สิ่งที่ควรคำนวณก่อนคือขนาดความเสี่ยงต่อออเดอร์ ซึ่งมือใหม่มักกำหนดไว้ที่ 1% ของพอร์ต',
        a2: 'ถ้าพอร์ต 500 ดอลลาร์และรับความเสี่ยง 1% คุณจะยอมเสียได้ไม้ละ 5 ดอลลาร์ ซึ่งเทรด EUR/USD ได้ราว 0.02-0.03 lot ที่ Stop Loss 20 Pip จึงควรเริ่มจากเงินที่หายไปแล้วไม่กระทบค่าใช้จ่าย และใช้บัญชีทดลองก่อนอย่างน้อย 1-3 เดือน',
      },
      {
        q: 'Forex เทรดได้ตลอด 24 ชั่วโมงหรือไม่',
        a: 'ตลาดเปิดต่อเนื่อง 24 ชั่วโมง 5 วันต่อสัปดาห์ เริ่มจากซิดนีย์ช่วงเย็นวันอาทิตย์ตามเวลาไทย และปิดเมื่อนิวยอร์กปิดช่วงเช้าวันเสาร์',
        a2: 'แม้เปิดตลอดเวลา แต่สภาพคล่องไม่เท่ากัน ช่วงที่ลอนดอนกับนิวยอร์กทับกันราว 19:00-23:00 น. ตามเวลาไทย Spread จะแคบที่สุด ส่วนช่วงปลายสัปดาห์ Spread มักกว้างขึ้น 2-3 เท่า',
      },
      {
        q: 'มือใหม่ควรเริ่มจากอะไรก่อน',
        a: 'เริ่มจากสี่เรื่องที่มีผลต่อเงินในพอร์ตโดยตรง คือคู่เงิน Pip Spread และ Leverage กับ Margin ก่อน จากนั้นจึงไปอ่านกราฟและฝึกตั้งคำสั่ง',
        a2: 'ถ้าเข้าใจสี่เรื่องนี้ การคำนวณขนาดออเดอร์ sẽทำได้เอง เช่น รู้ว่า EUR/USD 1 Pip = 10 ดอลลาร์ต่อ 1 lot ก็หารกับความเสี่ยงที่รับได้ได้ทันที ลำดับถัดไปคือฝึกบนบัญชีทดลองก่อนใช้เงินจริง',
      },
    ],
    related: ['currency-pairs', 'what-is-pip', 'how-to-trade-forex'],
  },
  {
    slug: 'currency-pairs',
    category: 'Forex พื้นฐาน',
    categorySlug: 'forex-basics',
    title: 'คู่เงินคืออะไร? รู้จัก Major, Minor และ Exotic Pairs',
    description:
      'อธิบายคู่เงินในตลาด Forex ทั้ง Major Minor และ Exotic Pairs พร้อมเหตุผลว่าทำไมมือใหม่ควรเริ่มจากคู่เงินหลัก',
    readingTime: '7 นาที',
    updatedDate: '2026-09-16',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20currency%20pair%20concept%20illustration%20teal%20and%20mint%20interlocking%20circles%20with%20warm%20orange%20accent%20on%20light%20background%20editorial%20flat%20design%20subtle%20grid%20no%20text%20no%20people&width=1200&height=675&seq=art-currency-pairs-01&orientation=landscape',
    tags: ['คู่เงิน', 'Major Pairs', 'พื้นฐาน'],
    intro: [
      'การเทรด Forex ทุกครั้งจะอยู่ในรูปแบบของคู่เงิน (Currency Pair) ซึ่งประกอบด้วยสกุลเงินฐานและสกุลเงินอ้างอิง ความเข้าใจเรื่องคู่เงินจะช่วยให้เลือกตลาดที่เหมาะกับสไตล์ของเราได้',
      'บทความนี้จะอธิบายความหมายของคู่เงินแต่ละประเภทและข้อดีข้อจำกัดของมัน',
    ],
    sections: [
      {
        id: 'pair-basics',
        heading: 'คู่เงินทำงานอย่างไร',
        paragraphs: [
          'คู่เงินอย่าง EUR/USD ตัวหน้า (EUR) คือสกุลเงินฐาน ส่วนตัวหลัง (USD) คือสกุลเงินอ้างอิง ราคาที่แสดงคือจำนวนสกุลเงินอ้างอิงที่ต้องใช้แลก 1 หน่วยของสกุลเงินฐาน',
        ],
        bullets: [
          'สกุลเงินฐานคือสิ่งที่เราซื้อหรือขาย',
          'สกุลเงินอ้างอิงคือสิ่งที่ใช้กำหนดราคา',
          'เมื่อราคาเพิ่มขึ้น สกุลเงินฐานแข็งค่าขึ้นเมื่อเทียบกับสกุลเงินอ้างอิง',
        ],
        steps: [],
      },
      {
        id: 'major-pairs',
        heading: 'Major Pairs คู่เงินหลัก',
        paragraphs: [
          'Major Pairs คือคู่เงินที่มีสกุลเงินดอลลาร์สหรัฐอยู่ด้วยและมีสภาพคล่องสูงที่สุด เหมาะกับมือใหม่เพราะ Spread ต่ำและเคลื่อนไหวคาดเดาง่ายกว่า',
        ],
        bullets: ['EUR/USD', 'GBP/USD', 'USD/JPY', 'USD/CHF', 'AUD/USD', 'USD/CAD'],
        steps: [],
      },
      {
        id: 'minor-exotic',
        heading: 'Minor และ Exotic Pairs',
        paragraphs: [
          'Minor Pairs หรือ Cross Pairs คือคู่เงินที่ไม่รวมดอลลาร์สหรัฐ เช่น EUR/GBP ส่วน Exotic Pairs คือคู่เงินของประเทศตลาดเกิดใหม่ที่มี Spread สูงและผันผวนมาก',
        ],
        bullets: [
          'Minor เช่น EUR/GBP, EUR/JPY, GBP/JPY',
          'Exotic เช่น USD/THB, USD/ZAR, USD/MXN',
          'Exotic ควรใช้ขนาดออเดอร์เล็กและระวังความผันผวนสูง',
        ],
        steps: [],
      },
      {
        id: 'which-to-choose',
        heading: 'มือใหม่ควรเลือกคู่เงินแบบไหน',
        paragraphs: [
          'แนะนำให้เริ่มจาก Major Pairs ที่ Spread ต่ำและมีข่าวสารให้ติดตามได้ง่าย เมื่อเข้าใจพฤติกรรมตลาดแล้วจึงค่อยขยายไปยังคู่เงินอื่น',
          'ตัวเลขที่ควรรู้คือ EURUSD และ USDJPY มี Spread ประมาณ 0.6 ถึง 1.2 Pip ในช่วง London กับ New York ส่วนคู่เงิน Exotic อย่าง USDZAR หรือ USDTRY อาจกว้าง 20 ถึง 50 Pip หมายความว่าถ้าเทรด Exotic ด้วยเป้ากำไร 30 Pip ต้นทุนจะกินกำไรไปกว่าครึ่งตั้งแต่เปิดออเดอร์',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'คู่เงินไหนเหมาะกับมือใหม่ที่สุด',
        a: 'EUR/USD เป็นคู่ที่เหมาะที่สุดสำหรับเริ่มต้น เพราะมีปริมาณซื้อขายสูงสุดในตลาด Spread มักอยู่ราว 0.5-1.5 Pip และมีข่าวให้ติดตามได้ทุกวัน',
        a2: 'รองลงมาคือ USD/JPY กับ GBP/USD ซึ่งยังมีสภาพคล่องดีแต่ผันผวนมากกว่า ควรหลีกเลี่ยงคู่ Exotic ในช่วงแรก เพราะ Spread อาจกว้าง 5-10 เท่าของคู่หลักและขยับแรงจากข่าวเพียงชิ้นเดียว',
      },
      {
        q: 'คู่เงิน Exotic อันตรายไหม',
        a: 'ค่อนข้างเสี่ยงสำหรับมือใหม่ เพราะ Spread กว้างกว่าคู่หลักหลายเท่า และราคาแกว่งแรงเมื่อมีข่าวการเมืองหรือเศรษฐกิจของประเทศนั้น',
        a2: 'เช่น USD/TRY หรือ USD/ZAR อาจมี Spread 20-50 Pip เทียบคู่หลักที่ 1 Pip แปลว่าต้นทุนเปิดออเดอร์สูงมาก และ Stop Loss ต้องกว้างขึ้นจน Lot ต้องเล็กลงมาก หากยังคำนวณไม่คล่อง ให้เริ่มจากคู่หลักก่อน',
      },
    ],
    related: ['what-is-forex', 'what-is-spread', 'what-is-pip'],
  },
  {
    slug: 'what-is-pip',
    category: 'Forex พื้นฐาน',
    categorySlug: 'forex-basics',
    title: 'Pip คืออะไร? เข้าใจหน่วยการเปลี่ยนแปลงของราคาใน Forex',
    description:
      'Pip คือหน่วยวัดการเคลื่อนไหวของราคาในตลาด Forex มาทำความเข้าใจความหมายและวิธีนับ Pip ให้ถูกต้อง',
    readingTime: '6 นาที',
    updatedDate: '2026-09-14',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20forex%20pip%20measurement%20concept%20teal%20ruler%20with%20warm%20orange%20markers%20on%20light%20clean%20background%20editorial%20flat%20design%20subtle%20grid%20texture%20no%20text&width=1200&height=675&seq=art-what-is-pip-01&orientation=landscape',
    tags: ['Pip', 'คำศัพท์', 'พื้นฐาน'],
    intro: [
      'Pip คือหน่วยพื้นฐานที่ใช้บอกว่าราคาเคลื่อนไหวไปเท่าไร เปรียบเหมือนหน่วยเซนติเมตรที่ใช้วัดการเปลี่ยนแปลงของราคา',
      'ทำความเข้าใจ Pip ให้ถูกต้องจะช่วยให้คำนวณกำไรขาดทุนและกำหนด Stop Loss ได้แม่นยำขึ้น',
    ],
    sections: [
      {
        id: 'what-is-pip',
        heading: 'Pip คืออะไร',
        paragraphs: [
          'Pip ย่อมาจาก Percentage in Point คือตำแหน่งทศนิยมมาตรฐานที่สุดท้ายของราคาคู่เงิน สำหรับคู่เงินส่วนใหญ่ Pip อยู่ที่ทศนิยมตำแหน่งที่ 4',
        ],
        bullets: [
          'EUR/USD เคลื่อนจาก 1.0842 เป็น 1.0843 = 1 Pip',
          'คู่เงิน JPY นับที่ทศนิยมตำแหน่งที่ 2',
          'Pipette หรือจุดที่ 5 คือเศษหนึ่งในสิบของ Pip',
        ],
        steps: [],
      },
      {
        id: 'pip-value',
        heading: 'Pip มีมูลค่าเท่าไหร่',
        paragraphs: [
          'มูลค่าของ 1 Pip ขึ้นอยู่กับขนาดสถานะ (Lot) และคู่เงิน โดยทั่วไป 1 Pip ต่อ 1 Standard Lot มีมูลค่าประมาณ 10 ดอลลาร์สหรัฐ',
        ],
        bullets: [
          'Standard Lot (1.00) ≈ 10 USD ต่อ Pip',
          'Mini Lot (0.10) ≈ 1 USD ต่อ Pip',
          'Micro Lot (0.01) ≈ 0.1 USD ต่อ Pip',
        ],
        steps: [],
      },
      {
        id: 'pip-in-practice',
        heading: 'นำ Pip ไปใช้อย่างไรในการเทรด',
        paragraphs: [
          'เทรดเดอร์ใช้ Pip ในการกำหนดจุด Stop Loss และ Take Profit เพื่อควบคุมความเสี่ยงให้เป็นตัวเลขที่ชัดเจนแทนการเดา',
        ],
        bullets: [
          'Stop Loss 25 Pips หมายถึงยอมให้ราคาสวนได้ 25 Pip',
          'Take Profit 50 Pips หมายถึงเป้าทำกำไรที่ 50 Pip',
          'คำนวณความเสี่ยงเป็นเงินได้จาก Pip และขนาดล็อต',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Pip กับ Point ต่างกันอย่างไร',
        a: 'Pip คือหน่วยนับการเคลื่อนไหวหลักของราคา ส่วน Point คือทศนิยมตำแหน่งถัดไปซึ่งมีค่าเพียง 0.1 Pip หรือที่เรียกว่า Pipette',
        a2: 'EUR/USD ที่ 1.08425 ขยับเป็น 1.08435 คือ 1 Point หรือ 0.1 Pip ถ้าโบรกเกอร์แจ้ง Spread หรือระยะ Stop Loss ขั้นต่ำเป็น Point ต้องหาร 10 ก่อนจึงจะเทียบกับ Pip ได้',
      },
      {
        q: 'ทำไมต้องรู้จัก Pip',
        a: 'เพราะ Pip เป็นหน่วยที่ใช้แปลงการเคลื่อนที่ของราคาเป็นจำนวนเงิน ใช้ทั้งตอนตั้ง Stop Loss คำนวณขนาด Lot และวัดกำไรขาดทุนจริง',
        a2: 'ถ้าไม่รู้ว่า 1 Pip ของคู่ที่เทรดมีค่าเท่าไร ก็ประเมินไม่ออกว่าออเดอร์นั้นเสี่ยงเป็นเงินเท่าใด เช่น 1 lot EUR/USD ให้ 10 ดอลลาร์ต่อ Pip แต่ 0.10 lot ให้เพียง 1 ดอลลาร์',
      },
    ],
    related: ['what-is-spread', 'how-to-calculate-lot', 'what-is-forex'],
  },
  {
    slug: 'what-is-spread',
    category: 'Forex พื้นฐาน',
    categorySlug: 'forex-basics',
    title: 'Spread คืออะไร? ส่วนต่างราคาที่เทรดเดอร์ต้องเข้าใจ',
    description:
      'Spread คือส่วนต่างระหว่างราคา Bid และ Ask ซึ่งเป็นต้นทุนแฝงในการเทรด มาทำความเข้าใจและวิธีดู Spread',
    readingTime: '6 นาที',
    updatedDate: '2026-09-12',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20bid%20ask%20spread%20concept%20two%20teal%20parallel%20lines%20with%20warm%20orange%20gap%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text&width=1200&height=675&seq=art-what-is-spread-01&orientation=landscape',
    tags: ['Spread', 'ต้นทุน', 'พื้นฐาน'],
    intro: [
      'Spread คือต้นทุนที่เทรดเดอร์จ่ายให้โบรกเกอร์ทุกครั้งที่เปิดออเดอร์ แม้จะไม่เห็นเป็นค่าธรรมเนียมตรง ๆ ก็ตาม',
      'บทความนี้จะอธิบายว่าราคา Bid กับ Ask คืออะไร และ Spread ส่งผลต่อการเทรดอย่างไร',
    ],
    sections: [
      {
        id: 'bid-ask',
        heading: 'ราคา Bid และ Ask',
        paragraphs: [
          'Bid คือราคาที่โบรกเกอร์ยอมซื้อจากเรา ใช้เมื่อเราต้องการ Sell ส่วน Ask คือราคาที่โบรกเกอร์ขายให้เรา ใช้เมื่อเราต้องการ Buy',
        ],
        bullets: [
          'Ask สูงกว่า Bid เสมอ',
          'ผลต่างระหว่าง Ask และ Bid คือ Spread',
          'ทันทีที่เปิดออเดอร์ ออเดอร์จะเริ่มติดลบเท่ากับ Spread',
        ],
        steps: [],
      },
      {
        id: 'spread-types',
        heading: 'Spread แบบคงที่และแบบลอยตัว',
        paragraphs: [
          'Spread บางครั้งถูกกำหนดคงที่ แต่ส่วนใหญ่เป็นแบบลอยตัวที่เปลี่ยนตามสภาพคล่องของตลาด ซึ่งจะกว้างขึ้นในช่วงเวลาเสี่ยง',
        ],
        bullets: [
          'ช่วงตลาดผันผวนหรือมีข่าวใหญ่ Spread จะกว้างขึ้น',
          'คู่เงินหลักมี Spread ต่ำกว่าคู่เงิน Exotic',
          'Spread ถูกกว่าไม่ได้แปลว่าดีที่สุดเสมอ ต้องดูคุณภาพการเทรดด้วย',
        ],
        steps: [],
      },
      {
        id: 'impact',
        heading: 'Spread ส่งผลต่อกำไรขาดทุนอย่างไร',
        paragraphs: [
          'ยิ่ง Spread กว้าง ราคาต้องเคลื่อนที่มากกว่าเดิมเพื่อให้ออเดอร์เริ่มกำไร การเทรดสั้น ๆ ถี่ ๆ จึงได้ผลดีกว่าบนคู่เงินที่ Spread ต่ำ',
          'ยกตัวอย่างให้เห็นชัด: ถ้า Spread 1.5 Pip แล้วตั้งเป้ากำไร 5 Pip ต้นทุนกินไป 30% ของกำไรก่อนราคาจะขยับเลย และถ้าเปิดวันละ 20 ไม้ด้วย 0.10 Lot ต้นทุน Spread รวมคือ 20 x 1.5 x 1 ดอลลาร์ = 30 ดอลลาร์ต่อวัน ซึ่งมากกว่ากำไรที่คนเริ่มต้นมักทำได้ทั้งสัปดาห์',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Spread กับค่าคอมมิชชั่นต่างกันไหม',
        a: 'ต่างกัน Spread คือส่วนต่างราคา Bid/Ask ที่ถูกหักทันทีตอนเปิดออเดอร์ ส่วนค่าคอมมิชชั่นเป็นค่าธรรมเนียมแยกที่คิดต่อ Lot ทั้งตอนเปิดและตอนปิด',
        a2: 'บัญชี ECN มักมี Spread ราว 0.1-0.3 Pip แต่คิดค่าคอมมิชชั่นประมาณ 3-7 ดอลลาร์ต่อ Lot ต่อรอบ ขณะที่บัญชี Standard ไม่มีค่าคอมมิชชั่นแต่ Spread กว้างกว่า ต้องเทียบต้นทุนรวมต่อออเดอร์จึงจะรู้ว่าอันไหนถูกกว่า',
      },
      {
        q: 'Spread กว้างตอนไหน',
        a: 'Spread กว้างขึ้นเมื่อสภาพคล่องต่ำ คือช่วงตลาดเปิดใหม่ ช่วงหลังประกาศข่าวเศรษฐกิจสำคัญ และช่วงใกล้ปิดตลาดวันศุกร์',
        a2: 'เช่น EUR/USD ที่ปกติ 1 Pip อาจกว้างเป็น 5-10 Pip ในไม่กี่วินาทีหลังประกาศเงินเฟ้อสหรัฐฯ การเปิดออเดอร์ช่วงนั้นจึงมีต้นทุนสูงและเสี่ยง Slippage ตามมา ควรเว้นอย่างน้อย 15 นาทีหลังข่าว',
      },
    ],
    related: ['what-is-pip', 'how-to-check-spread-mt4', 'currency-pairs'],
  },
  {
    slug: 'what-is-leverage',
    category: 'Forex พื้นฐาน',
    categorySlug: 'forex-basics',
    title: 'Leverage คืออะไร? เข้าใจอำนาจซื้อและความเสี่ยงที่มาพร้อมกัน',
    description:
      'Leverage ช่วยให้เทรดด้วยเงินก้อนใหญ่ขึ้นจากทุนน้อย แต่ก็เพิ่มความเสี่ยง มาทำความเข้าใจก่อนใช้งานจริง',
    readingTime: '7 นาที',
    updatedDate: '2026-09-10',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20leverage%20balance%20scale%20concept%20teal%20gear%20and%20warm%20orange%20weight%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text&width=1200&height=675&seq=art-what-is-leverage-01&orientation=landscape',
    tags: ['Leverage', 'ความเสี่ยง', 'พื้นฐาน'],
    intro: [
      'Leverage หรืออัตราทด เป็นเครื่องมือที่โบรกเกอร์ให้เทรดเดอร์ยืมเพื่อเปิดสถานะที่ใหญ่กว่าทุนที่มี มันเป็นทั้งโอกาสและความเสี่ยงในตัวเดียวกัน',
      'บทความนี้จะอธิบายว่า Leverage ทำงานอย่างไร และทำไมมือใหม่ต้องเข้าใจก่อนใช้',
    ],
    sections: [
      {
        id: 'leverage-meaning',
        heading: 'Leverage คืออะไร',
        paragraphs: [
          'Leverage คืออัตราส่วนระหว่างทุนที่ต้องใช้เปิดสถานะกับขนาดสถานะจริง เช่น Leverage 1:100 หมายถึงใช้เงิน 1 ส่วนคุมสถานะได้ 100 เท่า',
        ],
        bullets: [
          'Leverage 1:100 หมายถึงวางเงินประกัน 1% ของขนาดสถานะ',
          'Leverage ไม่ใช่เงินกู้ที่ต้องคืน แต่เป็นความสามารถในการคุมสถานะที่ใหญ่ขึ้น',
          'ความเสี่ยงจริงขึ้นอยู่กับขนาดสถานะ ไม่ใช่ตัวเลข Leverage เพียงอย่างเดียว',
        ],
        steps: [],
      },
      {
        id: 'risk',
        heading: 'ความเสี่ยงที่มาพร้อม Leverage',
        paragraphs: [
          'เพราะ Leverage ขยายทั้งกำไรและขาดทุน การใช้สถานะใหญ่เกินไปอาจทำให้พอร์ตถูกปิดสถานะอัตโนมัติ (Margin Call) ได้อย่างรวดเร็ว',
        ],
        bullets: [
          'ยิ่ง Leverage สูง ยิ่งคุมสถานะใหญ่ได้ แต่ก็ยิ่งเสี่ยง',
          'ควรกำหนดความเสี่ยงต่อออเดอร์ให้คงที่',
          'Leverage สูงไม่ใช่ใบอนุญาตให้เทรดหนักขึ้น',
        ],
        steps: [],
      },
      {
        id: 'best-practice',
        heading: 'ใช้ Leverage อย่างปลอดภัย',
        paragraphs: [
          'หัวใจไม่ได้อยู่ที่ใช้ Leverage เท่าไหร่ แต่อยู่ที่เลือกขนาดสถานะให้เหมาะกับความเสี่ยงที่รับได้ในแต่ละออเดอร์',
          'เพราะ Leverage ไม่ได้เปลี่ยนขนาดขาดทุนต่อ Pip ถ้าเปิด 0.10 Lot EURUSD ไว้ 1 Pip คือ 1 ดอลลาร์ ไม่ว่าจะใช้ Leverage 1:50 หรือ 1:500 สิ่งที่เปลี่ยนคือ Margin ที่ถูกกันไว้เท่านั้น คือประมาณ 217 ดอลลาร์ที่ 1:500 และ 2,170 ดอลลาร์ที่ 1:50 จากพอร์ต 5,000 ดอลลาร์',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Leverage สูงดีหรือไม่',
        a: 'Leverage สูงไม่ได้ทำให้ขาดทุนต่อ Pip มากขึ้น แต่ทำให้ใช้เงินประกันน้อยลงจนเปิดสถานะใหญ่ได้ง่ายขึ้น ซึ่งเป็นจุดที่มือใหม่มักพลาด',
        a2: 'ที่ 1:100 การเปิด 1 lot EUR/USD ต้องใช้ Margin ราว 1,000 ดอลลาร์ ที่ 1:500 ใช้เพียงราว 200 ดอลลาร์ แต่ขาดทุนต่อ Pip เท่ากันคือ 10 ดอลลาร์ พื้นที่รับแรงกระแทกของพอร์ตจึงน้อยลงมาก',
      },
      {
        q: 'Leverage กับ Margin ต่างกันอย่างไร',
        a: 'Leverage คืออัตราทดที่กำหนดว่าต้องใช้เงินประกันกี่เปอร์เซ็นต์ ส่วน Margin คือจำนวนเงินจริงที่ถูกกันไว้ขณะเปิดสถานะ',
        a2: 'Leverage 1:100 แปลว่าใช้ Margin 1% ของมูลค่าสัญญา ถ้าเปิด 1 lot EUR/USD มูลค่า 100,000 ดอลลาร์ จะถูกกันไว้ 1,000 ดอลลาร์ ส่วนที่เหลือยังเป็น Free Margin ซึ่งใช้เปิดออเดอร์อื่นได้',
      },
    ],
    related: ['what-is-margin', 'risk-management-basics', 'position-sizing'],
  },
  {
    slug: 'what-is-margin',
    category: 'Forex พื้นฐาน',
    categorySlug: 'forex-basics',
    title: 'Margin คืออะไร? เงินประกันที่ต้องรู้ก่อนเปิดสถานะ',
    description:
      'Margin คือเงินประกันที่ถูกกันไว้เมื่อเปิดสถานะ มาทำความเข้าใจ Margin, Free Margin และ Margin Call',
    readingTime: '7 นาที',
    updatedDate: '2026-09-08',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20margin%20collateral%20concept%20teal%20stacked%20blocks%20with%20warm%20orange%20reserved%20segment%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text&width=1200&height=675&seq=art-what-is-margin-01&orientation=landscape',
    tags: ['Margin', 'ความเสี่ยง', 'พื้นฐาน'],
    intro: [
      'Margin คือเงินประกันที่โบรกเกอร์กันไว้จากพอร์ตของเราเมื่อเปิดสถานะ มันไม่ใช่ค่าธรรมเนียม แต่เป็นเงินที่ยังเป็นของเราและจะคืนเมื่อปิดออเดอร์',
      'การเข้าใจ Margin จะช่วยให้รู้ว่าพอร์ตเรามีพื้นที่ให้เปิดออเดอร์เพิ่มได้อีกหรือไม่',
    ],
    sections: [
      {
        id: 'margin-meaning',
        heading: 'Margin คืออะไร',
        paragraphs: [
          'Margin คือจำนวนเงินขั้นต่ำที่ถูกกันไว้เพื่อค้ำประกันสถานะที่เปิดอยู่ คำนวณจากขนาดสถานะและอัตราทดที่โบรกเกอร์กำหนด',
        ],
        bullets: [
          'Required Margin คือเงินที่ถูกกันไว้ต่อออเดอร์',
          'Free Margin คือเงินที่เหลือและใช้เปิดออเดอร์ใหม่ได้',
          'Equity คือมูลค่าพอร์ตรวมที่รวมกำไรขาดทุนลอยตัว',
        ],
        steps: [],
      },
      {
        id: 'margin-call',
        heading: 'Margin Level และ Margin Call',
        paragraphs: [
          'Margin Level คืออัตราส่วนระหว่าง Equity กับ Margin ที่ใช้อยู่ หากลดต่ำกว่าระดับที่โบรกเกอร์กำหนดจะเกิด Margin Call และอาจถูกปิดออเดอร์อัตโนมัติ',
        ],
        bullets: [
          'Margin Level สูง = พอร์ตปลอดภัย',
          'Margin Level ต่ำ = เสี่ยงถูกเรียกเงินเพิ่มหรือปิดออเดอร์',
          'การตั้ง Stop Loss ช่วยลดโอกาสถูกปิดออเดอร์แบบไม่ทันตั้งตัว',
        ],
        steps: [],
      },
      {
        id: 'manage',
        heading: 'จัดการ Margin อย่างไรให้ปลอดภัย',
        paragraphs: [
          'กำหนดขนาดสถานะต่อออเดอร์ให้เล็กพอที่พอร์ตยังมี Free Margin เหลือ และไม่เปิดออเดอร์พร้อมกันหลายตัวจน Margin ตึงเกินไป',
          'เกณฑ์ที่ใช้ได้จริงคือปล่อยให้ Margin ที่ใช้ไปไม่เกิน 20 ถึง 30% ของพอร์ต เพราะเมื่อ Margin Level ลดต่ำกว่า 100% โบรกเกอร์จะเริ่มแจ้งเตือน และถ้าลงไปถึงระดับ Stop Out ที่มักอยู่ 50% ระบบจะปิดออเดอร์ให้อัตโนมัติ ซึ่งมักเกิดตอนที่คุณอยากถือออเดอร์ไว้มากที่สุด',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Margin คือเงินที่เสียไปหรือไม่',
        a: 'ไม่ใช่ Margin เป็นเงินที่ถูกกันไว้ชั่วคราวและจะคืนเข้ายอดเงินเมื่อปิดสถานะ จะหายไปก็ต่อเมื่อขาดทุนจริงจน Equity ลดลง',
        a2: 'เช่นพอร์ต 1,000 ดอลลาร์ใช้ Margin 200 ดอลลาร์เปิดออเดอร์ เงินในพอร์ตยังคงเป็น 1,000 ดอลลาร์ เพียงแต่ 200 ถูกกันไว้ ถ้าปิดออเดอร์ที่เท่าทุน เงินทั้ง 200 จะกลับมาเป็น Free Margin ตามเดิม',
      },
      {
        q: 'Margin Call คืออะไร',
        a: 'คือสัญญาณเตือนจากโบรกเกอร์เมื่อ Margin Level ของพอร์ตลดลงถึงเกณฑ์ที่กำหนด เช่น 100% เพื่อให้คุณเติมเงินหรือปิดสถานะบางส่วน',
        a2: 'ถ้าไม่ดำเนินการและ Margin Level ลดต่อถึงเกณฑ์ Stop Out เช่น 50% ระบบจะบังคับปิดออเดอร์อัตโนมัติ การตั้ง Stop Loss ล่วงหน้าจึงช่วยให้ออกตามแผนก่อนถึงจุดนั้น',
      },
    ],
    related: ['what-is-leverage', 'risk-management-basics', 'what-is-forex'],
  },
  {
    slug: 'how-forex-market-works',
    category: 'Forex พื้นฐาน',
    categorySlug: 'forex-basics',
    title: 'ตลาด Forex ทำงานอย่างไร? เข้าใจกลไก OTC และรอบเวลาเปิดตลาด',
    description:
      'อธิบายว่าตลาด Forex ทำงานอย่างไร ทำไมไม่มีศูนย์กลางการซื้อขาย ราคาถูกกำหนดจากอะไร และตลาดเปิดเป็นรอบตามเวลาโลกอย่างไร',
    readingTime: '8 นาที',
    updatedDate: '2026-09-21',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20decentralized%20forex%20market%20network%20concept%20teal%20nodes%20connected%20across%20a%20globe%20with%20warm%20orange%20accent%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text%20no%20people&width=1200&height=675&seq=art-how-forex-market-works-01&orientation=landscape',
    tags: ['ตลาด Forex', 'OTC', 'พื้นฐาน'],
    intro: [
      'หลายคนเข้าใจผิดว่าตลาด Forex มีศูนย์กลางการซื้อขายที่แน่นอนเหมือนตลาดหุ้น แต่ความจริงแล้วตลาด Forex ทำงานในรูปแบบเครือข่ายที่เชื่อมโยงกันทั่วโลก',
      'บทความนี้จะพาคุณเข้าใจกลไกการทำงานของตลาด Forex ตั้งแต่ราคาถูกกำหนดจากอะไร ไปจนถึงเหตุผลที่ตลาดเปิดซื้อขายได้เกือบตลอด 24 ชั่วโมง',
    ],
    sections: [
      {
        id: 'otc-market',
        heading: 'ตลาด Forex เป็นตลาดแบบ OTC',
        paragraphs: [
          'Forex เป็นตลาดแบบ Over-The-Counter (OTC) หมายความว่าไม่มีการซื้อขายผ่านตลาดกลางเพียงแห่งเดียว การซื้อขายเกิดขึ้นโดยตรงระหว่างคู่สัญญาผ่านเครือข่ายของธนาคาร โบรกเกอร์ และสถาบันการเงินที่เชื่อมโยงกันทั่วโลก',
          'เพราะไม่มีตลาดกลาง ราคาจึงไม่ได้ถูกกำหนดจากจุดเดียว แต่มาจากการแข่งขันของผู้ให้บริการสภาพคล่องหลายรายที่เสนอราคาแข่งขันกัน',
        ],
        bullets: [
          'ไม่มีที่ตั้งทางกายภาพหรือกระดานซื้อขายรวมศูนย์',
          'ซื้อขายผ่านเครือข่ายอิเล็กทรอนิกส์ระหว่างคู่สัญญา',
          'ราคาแต่ละโบรกเกอร์จึงอาจต่างกันเล็กน้อยจาก Spread และสภาพคล่อง',
        ],
        steps: [],
      },
      {
        id: 'price-drivers',
        heading: 'ราคาถูกกำหนดจากอุปสงค์และอุปทาน',
        paragraphs: [
          'ราคาคู่เงินในตลาด Forex เคลื่อนไหวตามอุปสงค์และอุปทานของสกุลเงินนั้น ๆ เมื่อมีคนต้องการซื้อสกุลเงินมากกว่าที่จะขาย ราคาก็จะปรับขึ้น และกลับกันเมื่อฝั่งขายมีมากกว่า',
          'อุปสงค์และอุปทานเหล่านี้ถูกผลักดันจากปัจจัยมหภาค เช่น อัตราดอกเบี้ย เงินเฟ้อ ตัวเลขเศรษฐกิจ ข่าวการเมือง และกระแสการลงทุนระหว่างประเทศ',
        ],
        bullets: [
          'อัตราดอกเบี้ยที่สูงขึ้นมักดึงดูดเงินทุนและหนุนค่าเงิน',
          'ข่าวเศรษฐกิจสำคัญทำให้ราคาแกว่งแรงในช่วงสั้น',
          'การคาดการณ์ของตลาดมีผลพอ ๆ กับตัวเลขจริงที่ออกมา',
        ],
        steps: [],
      },
      {
        id: 'market-sessions',
        heading: 'ตลาดเปิดเป็นรอบตามเวลาโลก',
        paragraphs: [
          'แม้ Forex จะเป็นเครือข่ายระดับโลก แต่การซื้อขายจะหมุนเวียนไปตามเวลาทำการของแต่ละศูนย์การเงินขนาดใหญ่ เริ่มจากซิดนีย์ ต่อด้วยโตเกียว ลอนดอน และนิวยอร์ก ทำให้มีสภาพคล่องต่อเนื่องเกือบตลอดวัน',
        ],
        bullets: [
          'ซิดนีย์เริ่มเปิดสัปดาห์และปิดท้ายเมื่อนิวยอร์กปิด',
          'แต่ละรอบมีสกุลเงินที่คึกคักต่างกันตามภูมิภาค',
          'ช่วงที่สองรอบคาบเกี่ยวกัน สภาพคล่องจะสูงที่สุด',
        ],
        steps: [],
      },
      {
        id: 'liquidity',
        heading: 'ช่วงเวลาที่สภาพคล่องสูงที่สุด',
        paragraphs: [
          'สภาพคล่องสูงหมายถึงมีคำสั่งซื้อขายหนาแน่น ทำให้ Spread แคบและราคาไหลลื่น ช่วงที่ลอนดอนและนิวยอร์กเปิดคาบเกี่ยวกันจึงเป็นช่วงที่มืออาชีพให้ความสนใจมากที่สุด',
          'ในทางกลับกัน ช่วงตลาดเงียบหรือใกล้วันหยุด สภาพคล่องจะต่ำลง Spread อาจกว้างขึ้นและราคาแกว่งผิดปกติได้ง่าย',
        ],
        bullets: [
          'ช่วงคาบเกี่ยวลอนดอน–นิวยอร์กมีสภาพคล่องหนาแน่นที่สุด',
          'ช่วงท้ายตลาดและก่อนข่าวใหญ่ Spread มักกว้างขึ้น',
          'มือใหม่ควรหลีกเลี่ยงการเทรดช่วงสภาพคล่องต่ำ',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ตลาด Forex มีศูนย์กลางไหม',
        a: 'ไม่มี Forex เป็นตลาดแบบ OTC ที่ซื้อขายผ่านเครือข่ายธนาคารและโบรกเกอร์ทั่วโลก จึงไม่มีกระดานซื้อขายรวมศูนย์แห่งเดียวเหมือนตลาดหุ้น',
        a2: 'ด้วยเหตุนี้ราคาจึงอาจต่างกันเล็กน้อยในแต่ละโบรกเกอร์ ขึ้นกับแหล่งสภาพคล่องที่แต่ละรายเชื่อมต่อ และไม่มีหน่วยงานกลางที่กำหนดราคาเดียวทั้งโลก',
      },
      {
        q: 'ราคา Forex ถูกกำหนดโดยใคร',
        a: 'ราคาถูกกำหนดจากอุปสงค์และอุปทานของผู้เข้าร่วมตลาดทั้งหมด โดยผู้ให้บริการสภาพคล่องรายใหญ่และธนาคารเป็นผู้เสนอราคาแข่งขันกัน',
        a2: 'ธนาคารกลางและกองทุนขนาดใหญ่มีอิทธิพลมากที่สุดเพราะคำสั่งมีมูลค่ามหาศาล ส่วนเทรดเดอร์รายย่อยเป็นเพียงผู้รับราคา จึงควรโฟกัสที่การจัดการความเสี่ยงมากกว่าคาดเดาเจตนาของรายใหญ่',
      },
      {
        q: 'ทำไม Spread ของแต่ละโบรกเกอร์ไม่เท่ากัน',
        a: 'เพราะแต่ละแห่งเชื่อมต่อแหล่งสภาพคล่องต่างกันและมีต้นทุนดำเนินงานต่างกัน Spread จึงสะท้อนคุณภาพการเชื่อมต่อและโมเดลธุรกิจของโบรกเกอร์นั้น',
        a2: 'โบรกเกอร์แบบ ECN ส่งคำสั่งเข้าตลาดจริงและคิดค่าคอมมิชชั่น ส่วนแบบ Market Maker อาจรับอีกฝั่งของออเดอร์เองและทำรายได้จาก Spread ที่กว้างขึ้น จึงควรเทียบต้นทุนรวมต่อ Lot ไม่ใช่ดูแค่ Spread',
      },
    ],
    related: ['what-is-forex', 'forex-market-hours', 'forex-market-participants'],
  },
  {
    slug: 'what-does-forex-trade',
    category: 'Forex พื้นฐาน',
    categorySlug: 'forex-basics',
    title: 'Forex ซื้อขายอะไร? ทำความเข้าใจการเทรดคู่เงินและสกุลเงิน',
    description:
      'Forex ซื้อขายคู่เงิน ไม่ใช่สกุลเงินเดี่ยว มาทำความเข้าใจว่าทำไมต้องซื้อขายเป็นคู่ มีคู่เงินแบบไหน และต่างจากตลาดหุ้นอย่างไร',
    readingTime: '7 นาที',
    updatedDate: '2026-09-19',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20currency%20exchange%20pairs%20concept%20two%20teal%20coins%20with%20warm%20orange%20bidirectional%20arrows%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text%20no%20people&width=1200&height=675&seq=art-what-does-forex-trade-01&orientation=landscape',
    tags: ['คู่เงิน', 'สกุลเงิน', 'พื้นฐาน'],
    intro: [
      'คำถามยอดนิยมของมือใหม่คือ Forex ซื้อขายอะไร คำตอบสั้น ๆ คือ ซื้อขาย "คู่เงิน" หรือการเทียบมูลค่าระหว่างสกุลเงินสองสกุลพร้อมกัน',
      'บทความนี้จะอธิบายว่าทำไมการเทรด Forex จึงต้องเป็นคู่ และตัวอย่างคู่เงินที่พบได้บ่อยในตลาด',
    ],
    sections: [
      {
        id: 'trade-currency-pairs',
        heading: 'ซื้อขายคู่เงิน ไม่ใช่สกุลเงินเดี่ยว',
        paragraphs: [
          'ในการเทรด Forex เราไม่ได้ซื้อหรือขายสกุลเงินใดสกุลเงินหนึ่งโดยลำพัง แต่เป็นการแลกเปลี่ยนสกุลเงินหนึ่งกับอีกสกุลหนึ่งพร้อมกันในรูปของคู่เงิน เช่น EUR/USD',
          'การซื้อ EUR/USD หมายความว่าเราซื้อสกุลเงินยูโรด้วยการจ่ายเป็นดอลลาร์สหรัฐในเวลาเดียวกัน ดังนั้นราคาที่แสดงจึงสะท้อนมูลค่าของยูโรเมื่อเทียบกับดอลลาร์เสมอ',
        ],
        bullets: [
          'ทุกออเดอร์คือการเทียบสองสกุลเงิน',
          'สกุลเงินหน้าเรียกว่าสกุลเงินฐาน สกุลเงินหลังเรียกว่าสกุลเงินอ้างอิง',
          'กำไรหรือขาดทุนมาจากส่วนต่างของราคา ไม่ได้ถือสกุลเงินจริง',
        ],
        steps: [],
      },
      {
        id: 'examples',
        heading: 'ตัวอย่างคู่เงินที่ถูกซื้อขาย',
        paragraphs: [
          'คู่เงินที่ซื้อขายกันมากที่สุดคือคู่เงินหลัก (Major Pairs) ที่มีดอลลาร์สหรัฐอยู่ด้วย และมีสกุลเงินอื่นอย่างยูโร เยน ปอนด์ และดอลลาร์ออสเตรเลีย',
          'นอกจากนี้ยังมีคู่เงินรอง (Minor Pairs) ที่ไม่รวมดอลลาร์สหรัฐ และคู่เงินเกิดใหม่ (Exotic Pairs) ที่ผันผวนสูงกว่า',
        ],
        bullets: [
          'Major เช่น EUR/USD, USD/JPY, GBP/USD',
          'Minor เช่น EUR/GBP, EUR/JPY',
          'Exotic เช่น USD/THB, USD/ZAR',
        ],
        steps: [],
      },
      {
        id: 'why-pairs',
        heading: 'ทำไมต้องซื้อขายเป็นคู่',
        paragraphs: [
          'เพราะมูลค่าของสกุลเงินหนึ่งจะมีความหมายก็ต่อเมื่อเทียบกับอีกสกุลเงินหนึ่ง เช่นเดียวกับการบอกว่าราคาสินค้าเป็นเงินเท่าไร เราจึงต้องมีหน่วยเทียบเสมอ',
          'การซื้อขายเป็นคู่ยังทำให้ตลาดมีสภาพคล่องสูง เพราะเทรดเดอร์สามารถเก็งกำไรจากทั้งขาขึ้นและขาลงได้โดยไม่ต้องมีสกุลเงินจริง',
        ],
        bullets: [
          'ราคาต้องมีหน่วยเทียบเสมอ',
          'สามารถทำกำไรได้ทั้งเมื่อค่าเงินแข็งและอ่อนค่า',
          'ความผันผวนของแต่ละคู่ขึ้นอยู่กับเศรษฐกิจของสองประเทศที่เกี่ยวข้อง',
        ],
        steps: [],
      },
      {
        id: 'vs-stocks',
        heading: 'ต่างจากการซื้อหุ้นอย่างไร',
        paragraphs: [
          'การซื้อหุ้นคือการเป็นเจ้าของบริษัทส่วนหนึ่งและมีสิทธิ์ในผลตอบแทนของบริษัท แต่การเทรด Forex คือการเก็งกำไรจากส่วนต่างของอัตราแลกเปลี่ยนโดยไม่ได้เป็นเจ้าของสกุลเงินจริง',
          'ตลาด Forex ยังเปิดเกือบตลอด 24 ชั่วโมงและมีสภาพคล่องสูงกว่าตลาดหุ้นมาก ทำให้ราคาไหลลื่นและมีต้นทุนการเทรดที่ต่ำกว่า',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'เทรด Forex ต้องถือสกุลเงินจริงไหม',
        a: 'ไม่ต้อง ออเดอร์ส่วนใหญ่เป็นการเก็งกำไรจากส่วนต่างราคา และจะถูกปิดเมื่อทำกำไรหรือขาดทุน ไม่มีการส่งมอบสกุลเงินจริง',
        a2: 'เช่นคุณ Buy EUR/USD 1 lot แล้วปิดในอีก 3 ชั่วโมง สิ่งที่เกิดขึ้นคือส่วนต่างราคาถูกคำนวณเป็นเงินในพอร์ต ไม่มีการโอนยูโร 100,000 เข้าบัญชีจริง การส่งมอบสกุลเงินมีเฉพาะในตลาดระหว่างธนาคารขนาดใหญ่',
      },
      {
        q: 'คู่เงินกับสกุลเงินต่างกันอย่างไร',
        a: 'สกุลเงินคือเงินตราเดี่ยว ๆ ส่วนคู่เงินคือการนำสกุลเงินสองสกุลมาเทียบมูลค่ากัน ซึ่งเป็นรูปแบบที่ใช้ซื้อขายจริงในตลาด Forex',
        a2: 'เช่น EUR คือสกุลเงิน แต่ EUR/USD คือคู่เงินที่บอกว่า 1 ยูโรแลกได้กี่ดอลลาร์ การเทรด Forex จึงต้องเลือกคู่เงินเสมอ ไม่สามารถซื้อขายสกุลเงินเดี่ยวได้',
      },
      {
        q: 'Forex เทรดได้ทั้งขึ้นและลงจริงไหม',
        a: 'จริง เพราะทุกออเดอร์อยู่ในรูปของคู่เงิน เราจึงเลือก Buy เมื่อคาดว่าสกุลเงินฐานจะแข็งค่า หรือ Sell เมื่อคาดว่าจะอ่อนค่าได้',
        a2: 'ถ้ามองว่า EUR/USD จะอ่อนลง คุณกด Sell เท่ากับขาย EUR และถือ USD ไว้ กำไรจะเกิดเมื่อราคาลดลง จึงเทรดได้ทั้งสองทางโดยไม่ต้องถือสินทรัพย์จริง',
      },
    ],
    related: ['currency-pairs', 'what-is-forex', 'how-forex-market-works'],
  },
  {
    slug: 'forex-market-participants',
    category: 'Forex พื้นฐาน',
    categorySlug: 'forex-basics',
    title: 'ใครเป็นผู้เข้าร่วมในตลาด Forex? รู้จักผู้เล่นหลักในตลาดเงินตรา',
    description:
      'ทำความรู้จักผู้เข้าร่วมตลาด Forex ตั้งแต่ธนาคารกลาง ธนาคารพาณิชย์ บริษัทและกองทุน ไปจนถึงเทรดเดอร์รายย่อยที่เราคุ้นเคย',
    readingTime: '7 นาที',
    updatedDate: '2026-09-17',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20forex%20market%20participants%20concept%20teal%20grouped%20circles%20with%20warm%20orange%20highlight%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text%20no%20people&width=1200&height=675&seq=art-forex-market-participants-01&orientation=landscape',
    tags: ['ผู้เล่นตลาด', 'สถาบัน', 'พื้นฐาน'],
    intro: [
      'ตลาด Forex ไม่ได้มีแค่เทรดเดอร์รายย่อยอย่างเรา แต่ประกอบด้วยผู้เล่นหลายระดับที่มีบทบาทและวัตถุประสงค์ต่างกัน บางกลุ่มเข้ามาเพื่อป้องกันความเสี่ยง บางกลุ่มเข้ามาเพื่อทำกำไร',
      'การรู้จักผู้เข้าร่วมแต่ละกลุ่มจะช่วยให้เข้าใจว่าทำไมราคาถึงเคลื่อนไหว และใครคือผู้กำหนดทิศทางตลาดในแต่ละช่วง',
    ],
    sections: [
      {
        id: 'central-banks',
        heading: 'ธนาคารกลาง',
        paragraphs: [
          'ธนาคารกลางเป็นผู้เล่นที่มีอิทธิพลสูงสุดในตลาดเงินตรา การกำหนดอัตราดอกเบี้ยและนโยบายการเงินส่งผลโดยตรงต่อมูลค่าสกุลเงินของประเทศนั้น',
          'บางครั้งธนาคารกลางยังเข้าแทรกแซงตลาดโดยตรงเพื่อรักษาเสถียรภาพของค่าเงิน หรือสะสมทุนสำรองเงินตราต่างประเทศ',
        ],
        bullets: [
          'กำหนดอัตราดอกเบี้ยและนโยบายการเงิน',
          'เข้าแทรกแซงค่าเงินในบางสถานการณ์',
          'การประชุมและถ้อยแถลงมีผลต่อความผันผวนอย่างมาก',
        ],
        steps: [],
      },
      {
        id: 'commercial-banks',
        heading: 'ธนาคารพาณิชย์ขนาดใหญ่',
        paragraphs: [
          'ธนาคารพาณิชย์เป็นกระดูกสันหลังของตลาด Forex เพราะทำหน้าที่เป็นผู้ให้บริการสภาพคล่องและเป็นผู้เสนอราคาให้ลูกค้า ธุรกรรมข้ามพรมแดนของลูกค้าองค์กรต้องผ่านธนาคารเหล่านี้',
          'ส่วนต่างระหว่างราคาที่ธนาคารเสนอซื้อและเสนอขายคือที่มาของ Spread ที่เราพบในแพลตฟอร์มเทรดนั่นเอง',
        ],
        bullets: [
          'เป็นผู้ให้บริการสภาพคล่องรายใหญ่',
          'เสนอราคาให้โบรกเกอร์และลูกค้าองค์กร',
          'ปริมาณซื้อขายต่อวันสูงกว่ากลุ่มอื่นมาก',
        ],
        steps: [],
      },
      {
        id: 'corporates',
        heading: 'บริษัทและสถาบันการเงิน',
        paragraphs: [
          'บริษัทที่ทำธุรกิจระหว่างประเทศ เช่น ผู้ส่งออก ผู้นำเข้า หรือบริษัทข้ามชาติ จำเป็นต้องแลกเปลี่ยนเงินตราเพื่อชำระค่าสินค้าและบริการ กลุ่มนี้จึงเข้ามาเพื่อป้องกันความเสี่ยงจากอัตราแลกเปลี่ยนเป็นหลัก',
          'แม้ปริมาณของแต่ละบริษัทจะไม่มากเท่าธนาคาร แต่โดยรวมแล้วมีมูลค่ามหาศาลและช่วยเพิ่มปริมาณการซื้อขายให้ตลาด',
        ],
        bullets: [
          'ใช้ Forex เพื่อป้องกันความเสี่ยงจากอัตราแลกเปลี่ยน',
          'แลกเปลี่ยนเงินตราตามรอบการค้าและงบการเงิน',
          'ไม่ได้เก็งกำไรเป็นหลักเหมือนเทรดเดอร์',
        ],
        steps: [],
      },
      {
        id: 'funds',
        heading: 'กองทุนและนักลงทุนสถาบัน',
        paragraphs: [
          'กองทุนรวม กองทุนป้องกันความเสี่ยง และนักลงทุนสถาบันเป็นกลุ่มที่ซื้อขายด้วยปริมาณมากและมีกลยุทธ์ซับซ้อน การปรับพอร์ตของพวกเขาสามารถสร้างแรงซื้อขายที่เห็นได้ชัดในตลาด',
        ],
        bullets: [
          'ซื้อขายด้วยขนาดสถานะใหญ่',
          'ใช้ข้อมูลและโมเดลวิเคราะห์เชิงลึก',
          'การปรับพอร์ตอาจทำให้ราคาแกว่งแรงในบางช่วง',
        ],
        steps: [],
      },
      {
        id: 'retail',
        heading: 'เทรดเดอร์รายย่อย',
        paragraphs: [
          'เทรดเดอร์รายย่อยคือบุคคลทั่วไปที่ทำการซื้อขายผ่านโบรกเกอร์ ด้วยเทคโนโลยีที่เข้าถึงง่ายในปัจจุบัน กลุ่มนี้เติบโตขึ้นมาก แม้ปริมาณซื้อขายของแต่ละคนจะเล็ก แต่โดยรวมมีผลต่อสภาพคล่องในระดับหนึ่ง',
          'สำหรับมือใหม่ สิ่งสำคัญคือเข้าใจว่าตนเองคือผู้เล่นรายเล็กในตลาดใหญ่ และควรบริหารความเสี่ยงให้รัดกุมเสมอ',
        ],
        bullets: [
          'ซื้อขายผ่านโบรกเกอร์ออนไลน์',
          'ขนาดออเดอร์ต่อรายเล็กกว่าสถาบันมาก',
          'ควรบริหารความเสี่ยงก่อนคาดหวังผลตอบแทน',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'เทรดเดอร์รายย่อยมีผลต่อราคาไหม',
        a: 'โดยรวมมีผลต่อสภาพคล่องในระดับหนึ่ง แต่ทิศทางตลาดหลักถูกขับเคลื่อนโดยธนาคารและนักลงทุนสถาบันเป็นส่วนใหญ่',
        a2: 'ปริมาณรวมของรายย่อยอาจใหญ่เป็นก้อนเดียว แต่กระจายและไม่มีวินัยร่วมกัน จึงไม่สามารถผลักราคาได้เหมือนกองทุน ควรใช้เวลาไปกับการอ่านโครงสร้างราคามากกว่าคาดเดาเจตนาของรายใหญ่',
      },
      {
        q: 'ทำไมธนาคารกลางถึงมีอิทธิพลมาก',
        a: 'เพราะอัตราดอกเบี้ยและนโยบายการเงินของธนาคารกลางส่งผลโดยตรงต่อความน่าดึงดูดของสกุลเงิน และสามารถแทรกแซงตลาดได้โดยตรง',
        a2: 'เช่นการขึ้นดอกเบี้ยของเฟดมักหนุนดอลลาร์ เพราะเงินฝากสกุลดอลลาร์ให้ผลตอบแทนสูงขึ้น และคำสั่งซื้อขายของธนาคารกลางเองมีขนาดใหญ่พอจะขยับราคาได้ทันที',
      },
      {
        q: 'กลุ่มไหนเข้ามาเพื่อป้องกันความเสี่ยง',
        a: 'กลุ่มบริษัทและสถาบันการเงินมักเข้ามาเพื่อป้องกันความเสี่ยงจากอัตราแลกเปลี่ยน มากกว่าการเก็งกำไรโดยตรง',
        a2: 'เช่นบริษัทนำเข้าส่งออกที่ต้องจ่ายเงินเป็นสกุลอื่นในอีก 3 เดือน จะล็อกอัตราแลกเปลี่ยนล่วงหน้าผ่านฟอร์เวิร์ดหรือสวอป เงินก้อนนี้จึงไม่ใช่การเก็งกำไร แต่เป็นต้นทุนธุรกิจ',
      },
    ],
    related: ['what-is-forex', 'how-forex-market-works', 'forex-market-hours'],
  },
  {
    slug: 'forex-market-hours',
    category: 'Forex พื้นฐาน',
    categorySlug: 'forex-basics',
    title: 'ตลาด Forex เปิดทำการกี่โมง? รู้จัก 4 รอบเวลาซื้อขายทั่วโลก',
    description:
      'ตลาด Forex เปิด 24 ชั่วโมง 5 วันต่อสัปดาห์ มาดู 4 รอบตลาดหลัก ซิดนีย์ โตเกียว ลอนดอน และนิวยอร์ก พร้อมช่วงเวลาที่เหมาะกับการเทรด',
    readingTime: '7 นาที',
    updatedDate: '2026-09-15',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20world%20market%20sessions%20timeline%20concept%20teal%20arc%20segments%20with%20warm%20orange%20marker%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text%20no%20people&width=1200&height=675&seq=art-forex-market-hours-01&orientation=landscape',
    tags: ['เวลาเปิดตลาด', 'รอบตลาด', 'พื้นฐาน'],
    intro: [
      'หนึ่งในข้อดีของตลาด Forex คือเปิดซื้อขายได้เกือบตลอด 24 ชั่วโมง 5 วันต่อสัปดาห์ แต่รู้หรือไม่ว่าตลาดไม่ได้ active เท่ากันทุกช่วงเวลา',
      'บทความนี้จะพาคุณรู้จัก 4 รอบตลาดหลักและช่วงเวลาที่น่าสนใจสำหรับการเทรด โดยเทียบเป็นเวลาไทย',
    ],
    sections: [
      {
        id: 'open-24-5',
        heading: 'ตลาดเปิด 24 ชั่วโมง 5 วันต่อสัปดาห์',
        paragraphs: [
          'ตลาด Forex เปิดทำการตั้งแต่ช่วงเย็นวันอาทิตย์ (ตามเวลาไทย) เมื่อตลาดซิดนีย์เริ่มเปิด และปิดในช่วงเช้าวันเสาร์เมื่อตลาดนิวยอร์กปิด รวมแล้วประมาณ 24 ชั่วโมง 5 วันต่อสัปดาห์',
          'การเปิดต่อเนื่องเช่นนี้เป็นเพราะศูนย์การเงินขนาดใหญ่กระจายอยู่ทั่วโลก จึงหมุนเวียนเปิดปิดต่อกันเป็นทอด ๆ',
        ],
        bullets: [
          'เปิดประมาณช่วงเย็นวันอาทิตย์ ถึงเช้าวันเสาร์ (เวลาไทย)',
          'เปิดต่อเนื่อง 24 ชั่วโมงในวันธรรมดา',
          'วันเสาร์–อาทิตย์ตลาดปิดทำการ',
        ],
        steps: [],
      },
      {
        id: 'four-sessions',
        heading: '4 รอบตลาดหลักและเวลาไทย',
        paragraphs: [
          'ตลาด Forex แบ่งการซื้อขายออกเป็น 4 รอบตามศูนย์การเงินหลัก โดยเวลาด้านล่างเป็นค่าประมาณตามเวลาไทย และอาจเลื่อนเล็กน้อยตามการปรับเวลาของแต่ละประเทศ',
        ],
        bullets: [
          'ซิดนีย์ เปิดประมาณ 04:00 – 13:00 น.',
          'โตเกียว เปิดประมาณ 07:00 – 16:00 น.',
          'ลอนดอน เปิดประมาณ 14:00 – 23:00 น.',
          'นิวยอร์ก เปิดประมาณ 19:00 – 04:00 น.',
        ],
        steps: [],
      },
      {
        id: 'best-time',
        heading: 'ช่วงเวลาที่เหมาะกับการเทรด',
        paragraphs: [
          'ช่วงที่ตลาดลอนดอนและนิวยอร์กเปิดคาบเกี่ยวกัน (ประมาณ 19:00 – 23:00 น. ตามเวลาไทย) เป็นช่วงที่สภาพคล่องสูงที่สุด Spread แคบที่สุด และคู่เงินหลักอย่าง EUR/USD และ GBP/USD เคลื่อนไหวคึกคักที่สุด',
          'สำหรับมือใหม่ ช่วงเวลานี้อาจเหมาะกับการสังเกตตลาด แต่ก็ควรระวังความผันผวนที่สูงขึ้นด้วยเช่นกัน',
        ],
        bullets: [
          'ช่วงคาบเกี่ยวลอนดอน–นิวยอร์ก สภาพคล่องสูงสุด',
          'ช่วงตลาดเปิดใหม่ ๆ ราคาอาจแกว่งแรงและ Spread กว้างขึ้น',
          'ช่วงท้ายวันศุกร์สภาพคล่องมักลดลงก่อนตลาดปิด',
        ],
        steps: [],
      },
      {
        id: 'market-close',
        heading: 'ตลาดปิดวันไหน',
        paragraphs: [
          'ตลาด Forex ปิดทำการทุกวันเสาร์และวันอาทิตย์ ตามเวลาไทยตลาดจะปิดตั้งแต่ช่วงเช้าวันเสาร์จนถึงเย็นวันอาทิตย์ และอาจปิดหรือซื้อขายเบาบางลงในบางวันหยุดสำคัญของประเทศใหญ่',
          'การเข้าใจเวลาปิด–เปิดนี้จะช่วยให้วางแผนการเทรดและเลือกช่วงเวลาที่เหมาะสมได้ดีขึ้น',
        ],
        bullets: [
          'ปิดสุดสัปดาห์ทุกสัปดาห์',
          'วันหยุดนักขัตฤกษ์ของสหรัฐฯ หรือยุโรปอาจทำให้ตลาดซื้อขายเบาบาง',
          'ควรหลีกเลี่ยงการเปิดออเดอร์ไว้ข้ามช่วงตลาดปิดหากไม่จำเป็น',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ตลาด Forex เปิดกี่โมงตามเวลาไทย',
        a: 'ตลาดจะเริ่มเปิดช่วงเย็นวันอาทิตย์เมื่อซิดนีย์เปิด และปิดช่วงเช้าวันเสาร์เมื่อนิวยอร์กปิด รวมเวลาเปิดต่อเนื่องประมาณ 24 ชั่วโมงในวันธรรมดา',
        a2: 'ช่วงเช้ามืดวันศุกร์ถึงเช้าวันเสาร์คือปลายตลาดที่สภาพคล่องเริ่มบาง หากต้องการปิดออเดอร์ก่อนสุดสัปดาห์ ควรทำช่วงลอนดอนหรือนิวยอร์กที่ยังมีคนซื้อขายหนาแน่น',
      },
      {
        q: 'ช่วงไหนเทรด Forex ดีที่สุด',
        a: 'ช่วงที่ลอนดอนและนิวยอร์กเปิดคาบเกี่ยวกันประมาณ 19:00 – 23:00 น. ตามเวลาไทย เป็นช่วงที่สภาพคล่องสูงและ Spread แคบที่สุด',
        a2: 'ช่วง 15:00-18:00 น. ที่ลอนดอนเปิดอย่างเดียวก็ใช้ได้ แต่ Spread จะแคบและแท่งเทียนชัดที่สุดในช่วงทับซ้อน ควรเลือกช่วงเดียวให้ชินก่อน ดีกว่าไล่เทรดทุกช่วง',
      },
      {
        q: 'เทรดช่วงตลาดปิดได้ไหม',
        a: 'ไม่ได้ ตลาดปิดทุกวันเสาร์–อาทิตย์ ไม่สามารถเปิดหรือปิดออเดอร์ได้ในช่วงเวลาดังกล่าว',
        a2: 'บางโบรกเกอร์ยังแสดงราคาและรับคำสั่งค้างไว้ (Pending) แต่จะถูกจับคู่เมื่อตลาดเปิด ซึ่งราคาอาจกระโดดห่างจากจุดที่ตั้งไว้มาก ถือเป็นความเสี่ยงที่ควรรู้',
      },
    ],
    related: ['how-forex-market-works', 'what-is-forex', 'forex-market-participants'],
  },
  {
    slug: 'major-minor-exotic-pairs',
    category: 'Forex พื้นฐาน',
    categorySlug: 'forex-basics',
    title: 'Major, Minor และ Exotic Pairs คืออะไร? แยกประเภทคู่เงินให้เข้าใจ',
    description:
      'อธิบายความต่างของ Major Minor และ Exotic Pairs พร้อมตัวอย่างคู่เงินในแต่ละกลุ่ม และเหตุผลที่มือใหม่ควรเริ่มจากคู่เงินหลัก',
    readingTime: '7 นาที',
    updatedDate: '2026-09-20',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20currency%20pair%20categories%20concept%20three%20tiered%20teal%20groups%20with%20warm%20orange%20accent%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text%20no%20people&width=1200&height=675&seq=art-major-minor-exotic-pairs-01&orientation=landscape',
    tags: ['คู่เงิน', 'Major Pairs', 'Exotic Pairs'],
    intro: [
      'คู่เงินในตลาด Forex มีมากมายหลายสิบคู่ และถูกจัดกลุ่มตามสภาพคล่องและความผันผวน การเข้าใจว่าคู่เงินแต่ละกลุ่มต่างกันอย่างไรจะช่วยให้เลือกตลาดที่เหมาะกับสไตล์และระดับความเสี่ยงของเรา',
      'บทความนี้จะแยกให้เห็นชัดว่า Major Minor และ Exotic Pairs ต่างกันตรงไหน พร้อมข้อควรระวังในแต่ละกลุ่ม',
    ],
    sections: [
      {
        id: 'major-pairs',
        heading: 'Major Pairs คู่เงินหลัก',
        paragraphs: [
          'Major Pairs คือคู่เงินที่มีดอลลาร์สหรัฐอยู่ทั้งสองฝั่งของคู่ และเป็นคู่เงินที่มีการซื้อขายหนาแน่นที่สุดในโลก ด้วยสภาพคล่องสูงทำให้ Spread แคบและราคาไหลลื่น',
        ],
        bullets: [
          'EUR/USD, GBP/USD, USD/JPY, USD/CHF, AUD/USD, USD/CAD',
          'มีดอลลาร์สหรัฐอยู่ในคู่เสมอ',
          'Spread ต่ำและมีข่าวสารให้ติดตามมากที่สุด',
        ],
        steps: [],
      },
      {
        id: 'minor-pairs',
        heading: 'Minor Pairs หรือ Cross Pairs',
        paragraphs: [
          'Minor Pairs คือคู่เงินที่ไม่มีดอลลาร์สหรัฐอยู่ในคู่ มักเป็นการเทียบระหว่างสกุลเงินหลักด้วยกันเอง สภาพคล่องรองลงมาจาก Major Pairs แต่ยังถือว่าดีในระดับหนึ่ง',
        ],
        bullets: [
          'ตัวอย่างเช่น EUR/GBP, EUR/JPY, GBP/JPY',
          'Spread กว้างกว่า Major เล็กน้อย',
          'เคลื่อนไหวตามเศรษฐกิจของสองภูมิภาคที่เกี่ยวข้อง',
        ],
        steps: [],
      },
      {
        id: 'exotic-pairs',
        heading: 'Exotic Pairs คู่เงินตลาดเกิดใหม่',
        paragraphs: [
          'Exotic Pairs คือคู่เงินที่จับคู่สกุลเงินหลักกับสกุลเงินของประเทศตลาดเกิดใหม่ สภาพคล่องต่ำกว่าและความผันผวนสูงกว่า จึงมี Spread ที่กว้างกว่าอย่างชัดเจน',
        ],
        bullets: [
          'ตัวอย่างเช่น USD/THB, USD/ZAR, USD/MXN, USD/TRY',
          'Spread กว้างและราคาแกว่งแรง',
          'ควรใช้ขนาดออเดอร์เล็กและระวังความเสี่ยงเป็นพิเศษ',
        ],
        steps: [],
      },
      {
        id: 'which-to-choose',
        heading: 'มือใหม่ควรเลือกแบบไหน',
        paragraphs: [
          'สำหรับมือใหม่ คู่เงินหลักอย่าง EUR/USD เป็นจุดเริ่มต้นที่ดีที่สุด เพราะ Spread ต่ำ มีสภาพคล่องสูง และมีข้อมูลข่าวสารให้ศึกษาง่าย เมื่อเข้าใจพฤติกรรมตลาดดีแล้วจึงค่อยขยับไปคู่เงินกลุ่มอื่น',
          'เทียบให้เห็นชัดคือ EUR/USD เคลื่อนไหวเฉลี่ยวันละ 60 ถึง 80 Pip ในช่วงตลาดปกติ ขณะที่ GBP/USD มักแกว่ง 100 ถึง 130 Pip ด้วยค่าเงินที่ผันผวนกว่า ถ้าตั้ง Stop Loss 30 Pip บน GBP/USD คุณมีโอกาสถูกตัดก่อนราคาไปต่อมากกว่าเกือบเท่าตัว',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Major กับ Minor ต่างกันอย่างไร',
        a: 'Major Pairs มีดอลลาร์สหรัฐอยู่ในคู่เสมอและมีสภาพคล่องสูงสุด ส่วน Minor Pairs ไม่มีดอลลาร์สหรัฐและสภาพคล่องรองลงมา',
        a2: 'เช่น EUR/USD, USD/JPY, GBP/USD เป็น Major ส่วน EUR/GBP กับ AUD/NZD เป็น Minor ที่ Spread กว้างกว่าเล็กน้อย มือใหม่มักเริ่มจาก Major เพื่อเรียนรู้พฤติกรรมตลาดก่อน',
      },
      {
        q: 'Exotic Pairs เหมาะกับมือใหม่ไหม',
        a: 'ไม่ค่อยเหมาะ เพราะ Spread กว้างและผันผวนสูง มือใหม่ควรเริ่มจากคู่เงินหลักก่อนเพื่อเรียนรู้พฤติกรรมตลาด',
        a2: 'คู่อย่าง USD/TRY หรือ USD/MXN อาจแกว่ง 2-3% ในวันเดียวจากข่าวการเมือง ขณะที่คู่หลักมักขยับไม่ถึง 1% ความเสี่ยงต่อไม้จึงสูงกว่าหลายเท่าในขนาด Lot ที่เท่ากัน',
      },
      {
        q: 'คู่เงินไหนมี Spread ต่ำที่สุด',
        a: 'คู่เงินหลักอย่าง EUR/USD มักมี Spread ต่ำที่สุด เพราะมีปริมาณซื้อขายและสภาพคล่องสูงที่สุดในตลาด',
        a2: 'โดยทั่วไป EUR/USD กับ USD/JPY อยู่ในกลุ่มต่ำสุดที่ราว 0.5-1.5 Pip ในช่วงตลาดคึกคัก แต่ช่วงก่อนเปิดตลาดอาจกว้างขึ้น 2-3 เท่า ควรดูก่อนกดทุกครั้งจากหน้าต่าง New Order',
      },
    ],
    related: ['currency-pairs', 'base-quote-currency', 'bid-and-ask'],
  },
  {
    slug: 'base-quote-currency',
    category: 'Forex พื้นฐาน',
    categorySlug: 'forex-basics',
    title: 'Base Currency และ Quote Currency คืออะไร? อ่านคู่เงินให้ถูกต้อง',
    description:
      'ทำความเข้าใจสกุลเงินฐานและสกุลเงินอ้างอิงในคู่เงิน วิธีอ่านราคา และรู้ได้อย่างไรว่าสกุลเงินไหนกำลังแข็งค่าหรืออ่อนค่า',
    readingTime: '7 นาที',
    updatedDate: '2026-09-18',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20base%20and%20quote%20currency%20concept%20two%20teal%20blocks%20with%20warm%20orange%20equals%20symbol%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text%20no%20people&width=1200&height=675&seq=art-base-quote-currency-01&orientation=landscape',
    tags: ['คู่เงิน', 'สกุลเงินฐาน', 'พื้นฐาน'],
    intro: [
      'ทุกคู่เงินจะประกอบด้วยสกุลเงินสองสกุลที่เรียงต่อกันเสมอ ตำแหน่งหน้าและหลังของคู่เงินมีความหมายชัดเจน และเป็นพื้นฐานสำคัญที่มือใหม่ต้องอ่านให้ออก',
      'บทความนี้จะอธิบายว่าสกุลเงินฐานและสกุลเงินอ้างอิงคืออะไร และวิธีอ่านราคาคู่เงินให้เข้าใจความหมายที่แท้จริง',
    ],
    sections: [
      {
        id: 'base-currency',
        heading: 'Base Currency (สกุลเงินฐาน) คืออะไร',
        paragraphs: [
          'สกุลเงินฐานคือสกุลเงินตัวหน้าของคู่เงิน เป็นสกุลเงินที่เรากำลังซื้อหรือขายโดยอ้างอิงกับอีกสกุลหนึ่ง ในคู่ EUR/USD ตัว EUR คือสกุลเงินฐาน',
        ],
        bullets: [
          'เป็นสกุลเงินตัวหน้าเสมอ',
          'ราคาแสดงเป็นมูลค่าของ 1 หน่วยสกุลเงินฐาน',
          'เมื่อเลือก Buy EUR/USD เรากำลังซื้อสกุลเงินฐาน',
        ],
        steps: [],
      },
      {
        id: 'quote-currency',
        heading: 'Quote Currency (สกุลเงินอ้างอิง) คืออะไร',
        paragraphs: [
          'สกุลเงินอ้างอิงคือสกุลเงินตัวหลังของคู่เงิน เป็นสกุลเงินที่ใช้กำหนดราคาและใช้ในการชำระเมื่อแลกเปลี่ยน ในคู่ EUR/USD ตัว USD คือสกุลเงินอ้างอิง',
        ],
        bullets: [
          'เป็นสกุลเงินตัวหลังเสมอ',
          'ใช้ระบุวาต้องใช้กี่หน่วยในการแลก 1 หน่วยสกุลเงินฐาน',
          'เมื่อเลือก Sell EUR/USD เรากำลังขายสกุลเงินฐานเพื่อรับสกุลเงินอ้างอิง',
        ],
        steps: [],
      },
      {
        id: 'read-pair',
        heading: 'อ่านราคาคู่เงินอย่างไร',
        paragraphs: [
          'ถ้าคู่ EUR/USD แสดงราคา 1.0850 หมายความว่าใช้ 1.0850 ดอลลาร์สหรัฐเพื่อแลก 1 ยูโร เมื่อราคาเลขนี้เพิ่มขึ้น แสดงว่ายูโรแข็งค่าขึ้นเมื่อเทียบกับดอลลาร์ หรือดอลลาร์อ่อนค่าลงนั่นเอง',
        ],
        bullets: [
          'ราคาคือจำนวนสกุลเงินอ้างอิงต่อ 1 หน่วยสกุลเงินฐาน',
          'ราคาเพิ่ม = สกุลเงินฐานแข็งค่าขึ้น',
          'ราคาลด = สกุลเงินฐานอ่อนค่าลง',
        ],
        steps: [],
      },
      {
        id: 'strength',
        heading: 'รู้ได้อย่างไรว่าสกุลเงินไหนแข็งค่า',
        paragraphs: [
          'การแข็งหรืออ่อนค่าของสกุลเงินจะสัมพันธ์กันเป็นคู่เสมอ เมื่อคู่หนึ่งสกุลเงินฐานแข็งขึ้น อีกฝั่งหนึ่งจะอ่อนลงในทันที การดูภาพรวมของหลาย ๆ คู่จะช่วยให้เห็นความแข็ง–อ่อนของสกุลเงินแต่ละตัวได้ชัดเจนขึ้น',
        ],
        bullets: [
          'การแข็งค่าของสกุลหนึ่งคือการอ่อนค่าของอีกสกุล',
          'ดูจากหลายคู่พร้อมกันเพื่อเห็นภาพรวมจริง',
          'ปัจจัยอย่างอัตราดอกเบี้ยและข่าวเศรษฐกิจเป็นตัวขับเคลื่อนหลัก',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'สกุลเงินฐานอยู่ตำแหน่งไหนเสมอ',
        a: 'สกุลเงินฐานอยู่ในตำแหน่งหน้าของคู่เงินเสมอ เช่นใน EUR/USD ตัว EUR คือสกุลเงินฐาน',
        a2: 'ใน USD/JPY ตัว USD คือสกุลเงินฐาน และ JPY คือสกุลเงินอ้างอิง ราคา 148.10 จึงหมายถึง 1 ดอลลาร์แลกได้ 148.10 เยน การอ่านให้ถูกตำแหน่งมีผลต่อการตีความกำไรขาดทุน',
      },
      {
        q: 'ราคา EUR/USD เพิ่มขึ้นหมายความว่าอะไร',
        a: 'หมายความว่า 1 ยูโรแลกได้ดอลลาร์สหรัฐมากขึ้น หรือยูโรแข็งค่าขึ้นเมื่อเทียบกับดอลลาร์นั่นเอง',
        a2: 'จาก 1.0800 ไปเป็น 1.0900 คือยูโรแข็งค่าขึ้น 100 Pip ถ้าคุณถือ Buy 1 lot จะได้กำไรราว 1,000 ดอลลาร์ สวนทางกับคนที่ถือ Sell ในขนาดเท่ากัน',
      },
      {
        q: 'ทำไมต้องรู้จักสกุลเงินฐานและอ้างอิง',
        a: 'เพราะมันช่วยให้เข้าใจว่าราคาที่แสดงหมายถึงอะไร และเรากำลังซื้อหรือขายสกุลเงินใดเมื่อเปิดออเดอร์',
        a2: 'เมื่อรู้ว่ากำลังซื้อหรือขายสกุลใด จะเข้าใจทันทีว่าอะไรทำให้ราคาขึ้น เช่นการ Buy EUR/USD คือการเดิมพันว่ายูโรจะแข็งค่าหรือดอลลาร์จะอ่อนค่าลง',
      },
    ],
    related: ['currency-pairs', 'exchange-rate', 'major-minor-exotic-pairs'],
  },
  {
    slug: 'bid-and-ask',
    category: 'Forex พื้นฐาน',
    categorySlug: 'forex-basics',
    title: 'Bid และ Ask คืออะไร? เข้าใจราคาสองฝั่งในตลาด Forex',
    description:
      'Bid และ Ask คือราคาซื้อขายสองฝั่งที่เทรดเดอร์เจอทุกครั้ง มาทำความเข้าใจความหมาย ผลต่างระหว่างกัน และวิธีนำไปใช้ตอนเปิดออเดอร์',
    readingTime: '6 นาที',
    updatedDate: '2026-09-16',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20bid%20and%20ask%20price%20concept%20two%20teal%20horizontal%20lines%20with%20warm%20orange%20gap%20between%20them%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text%20no%20people&width=1200&height=675&seq=art-bid-and-ask-01&orientation=landscape',
    tags: ['Bid', 'Ask', 'ราคา'],
    intro: [
      'เมื่อดูราคาคู่เงินบนแพลตฟอร์มเทรด เราจะเห็นตัวเลขสองตัวเสมอ นั่นคือราคา Bid และ Ask ซึ่งเป็นหัวใจของการซื้อขายในตลาด Forex',
      'บทความนี้จะอธิบายว่าราคาทั้งสองฝั่งต่างกันอย่างไร และทำไมเราจึงเปิดออเดอร์ด้วยราคาที่ไม่เท่ากันเสมอ',
    ],
    sections: [
      {
        id: 'bid',
        heading: 'Bid คืออะไร',
        paragraphs: [
          'Bid คือราคาที่โบรกเกอร์หรือตลาดพร้อมจะซื้อคู่เงินจากเรา เป็นราคาที่ใช้เมื่อเราต้องการขาย (Sell) โดยทั่วไป Bid จะเป็นราคาที่ต่ำกว่า Ask เสมอ',
        ],
        bullets: [
          'ใช้เมื่อเราต้องการ Sell',
          'เป็นราคาที่ตลาดยอมรับซื้อจากเรา',
          'เป็นราคาด้านล่างที่แสดงบนแพลตฟอร์ม',
        ],
        steps: [],
      },
      {
        id: 'ask',
        heading: 'Ask คืออะไร',
        paragraphs: [
          'Ask คือราคาที่โบรกเกอร์หรือตลาดพร้อมจะขายคู่เงินให้เรา เป็นราคาที่ใช้เมื่อเราต้องการซื้อ (Buy) ซึ่งสูงกว่าราคา Bid เสมอ',
        ],
        bullets: [
          'ใช้เมื่อเราต้องการ Buy',
          'เป็นราคาที่ตลาดขายให้เรา',
          'เป็นราคาด้านบนที่แสดงบนแพลตฟอร์ม',
        ],
        steps: [],
      },
      {
        id: 'spread-link',
        heading: 'Bid กับ Ask ต่างกันเท่าไร',
        paragraphs: [
          'ผลต่างระหว่างราคา Ask และ Bid เรียกว่า Spread ซึ่งเป็นต้นทุนแฝงที่เทรดเดอร์จ่ายทุกครั้งที่เปิดออเดอร์ ยิ่ง Spread แคบ ตันทุนต่อออเดอร์ยิ่งต่ำ',
        ],
        bullets: [
          'Spread = Ask − Bid',
          'คู่เงินหลักมี Spread แคบกว่าคู่เงิน Exotic',
          'ทันทีที่เปิดออเดอร์ ออเดอร์จะเริ่มติดลบเท่ากับ Spread',
        ],
        steps: [],
      },
      {
        id: 'apply',
        heading: 'นำไปใช้ตอนเปิดออเดอร์',
        paragraphs: [
          'เมื่อคุณกด Buy คำสั่งจะถูกจับคู่ที่ราคา Ask ส่วนเมื่อกด Sell คำสั่งจะถูกจับคู่ที่ราคา Bid เข้าใจกลไกนี้จะช่วยให้คุณคำนวณต้นทุนและวางแผนกำไรขาดทุนได้แม่นยำขึ้น',
          'ตัวอย่างจริงบนหน้าจอ: ถ้า Bid 1.08500 และ Ask 1.08512 คุณกด Buy จะเข้าที่ 1.08512 ทันที ต้องรอราคาขึ้นไปถึง 1.08524 จึงจะเท่าทุน ขณะที่ฝั่ง Sell เข้าที่ 1.08500 และเท่าทุนเมื่อลงไป 1.08488 ความต่าง 1.2 Pip นี้คือ Spread ที่คุณจ่ายให้ตลาดในทุกไม้',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ทำไมราคา Bid กับ Ask ถึงไม่เท่ากัน',
        a: 'เพราะส่วนต่างนี้คือรายได้ของผู้ให้บริการสภาพคล่องและเป็นต้นทุนการเทรดของเรา ซึ่งก็คือ Spread นั่นเอง',
        a2: 'เช่น Bid 1.0848 กับ Ask 1.0850 ห่างกัน 2 Pip แปลว่าเปิดออเดอร์แล้วต้องรอราคาเดินไป 2 Pip จึงจะเท่าทุน นี่คือเหตุผลที่ Scalping ต้องเลือกต้นทุนให้ต่ำ',
      },
      {
        q: 'ควร Buy หรือ Sell ที่ราคาไหน',
        a: 'เมื่อ Buy จะจับคู่ที่ราคา Ask และเมื่อ Sell จะจับคู่ที่ราคา Bid โดยราคา Bid จะต่ำกว่า Ask เสมอ',
        a2: 'ถ้า Buy ที่ Ask 1.0850 แล้วปิดทันทีที่ Bid 1.0848 จะขาดทุน 2 Pip ทันที เพราะต้องขายคืนที่ราคา Bid นี่คือเหตุผลที่ออเดอร์ใหม่มักติดลบทันที',
      },
      {
        q: 'Bid กับ Ask เกี่ยวกับ Spread อย่างไร',
        a: 'Spread คือผลต่างระหว่างราคาทั้งสองฝั่ง ยิ่ง Bid กับ Ask ห่างกันมาก Spread ก็ยิ่งกว้างและต้นทุนการเทรดสูงขึ้น',
        a2: 'Spread คือ Ask ลบ Bid ถ้าโบรกเกอร์แจ้ง Spread 1.5 Pip บน EUR/USD ก็คาดได้ว่าส่วนต่างราคาจะประมาณ 0.00015 การขยายตัวของส่วนต่างนี้คือต้นทุนที่เพิ่มขึ้นตรง ๆ ต่อทุกออเดอร์',
      },
    ],
    related: ['what-is-spread', 'base-quote-currency', 'currency-pairs'],
  },
  {
    slug: 'exchange-rate',
    category: 'Forex พื้นฐาน',
    categorySlug: 'forex-basics',
    title: 'อัตราแลกเปลี่ยนคืออะไร? ปัจจัยที่ทำให้ค่าเงินเคลื่อนไหว',
    description:
      'อัตราแลกเปลี่ยนคือราคาแลกเปลี่ยนระหว่างสองสกุลเงิน มาทำความเข้าใจความหมาย วิธีกำหนดราคา และปัจจัยที่ทำให้ค่าเงินเคลื่อนไหว',
    readingTime: '7 นาที',
    updatedDate: '2026-09-13',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20exchange%20rate%20concept%20teal%20arrow%20curve%20rising%20and%20falling%20with%20warm%20orange%20marker%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text%20no%20people&width=1200&height=675&seq=art-exchange-rate-01&orientation=landscape',
    tags: ['อัตราแลกเปลี่ยน', 'ค่าเงิน', 'พื้นฐาน'],
    intro: [
      'อัตราแลกเปลี่ยนคือราคาที่บอกว่าเราต้องใช้เงินจำนวนเท่าไรเพื่อแลกสกุลเงินหนึ่งกับอีกสกุลหนึ่ง เป็นข้อมูลพื้นฐานที่สุดที่อยู่เบื้องหลังทุกการเทรด Forex',
      'ทำความเข้าใจว่าอัตราแลกเปลี่ยนถูกกำหนดจากอะไรและทำไมมันถึงเปลี่ยนแปลงตลอดเวลาจะช่วยให้เรามองตลาดได้อย่างมีเหตุผลมากขึ้น',
    ],
    sections: [
      {
        id: 'meaning',
        heading: 'อัตราแลกเปลี่ยนคืออะไร',
        paragraphs: [
          'อัตราแลกเปลี่ยน (Exchange Rate) คือราคาของสกุลเงินหนึ่งที่แสดงเป็นอีกสกุลเงินหนึ่ง เช่น 1 ยูโรเท่ากับ 1.0850 ดอลลาร์สหรัฐ อัตรานี้คือสิ่งที่เรามองเห็นในรูปของราคาคู่เงินนั่นเอง',
        ],
        bullets: [
          'บอกมูลค่าของสกุลเงินหนึ่งเมื่อเทียบกับอีกสกุล',
          'เปลี่ยนแปลงตลอดเวลาตามอุปสงค์และอุปทาน',
          'เป็นพื้นฐานของราคาคู่เงินทุกคู่ใน Forex',
        ],
        steps: [],
      },
      {
        id: 'quoted',
        heading: 'อัตราแลกเปลี่ยนถูกกำหนดอย่างไร',
        paragraphs: [
          'ในตลาด Forex อัตราแลกเปลี่ยนไม่ได้ถูกประกาศจากรัฐบาลเพียงแห่งเดียว แต่ถูกกำหนดจากอุปสงค์และอุปทานของสกุลเงินนั้น ๆ ผ่านการซื้อขายของผู้เข้าร่วมตลาดทั่วโลก',
          'สำหรับบางประเทศที่ควบคุมค่าเงิน อัตราอาจถูกกำหนดหรือแทรกแซงโดยธนาคารกลางด้วย แต่สกุลเงินหลักส่วนใหญ่เป็นแบบลอยตัว',
        ],
        bullets: [
          'สกุลเงินลอยตัวกำหนดจากตลาดเป็นหลัก',
          'บางประเทศมีระบบค่าเงินที่ถูกควบคุมบางส่วน',
          'การแทรกแซงของธนาคารกลางอาจส่งผลต่ออัตราในระยะสั้น',
        ],
        steps: [],
      },
      {
        id: 'drivers',
        heading: 'ปัจจัยที่ทำให้ค่าเงินเคลื่อนไหว',
        paragraphs: [
          'อัตราแลกเปลี่ยนไม่ได้ขยับเพราะการคาดเดาของเทรดเดอร์เท่านั้น แต่สะท้อนสภาวะเศรษฐกิจและนโยบายของแต่ละประเทศด้วย',
        ],
        bullets: [
          'อัตราดอกเบี้ยและนโยบายการเงิน',
          'อัตราเงินเฟ้อและตัวเลขเศรษฐกิจ',
          'ข่าวการเมือง ความเชื่อมั่น และดุลการค้า',
        ],
        steps: [],
      },
      {
        id: 'impact',
        heading: 'อัตราแลกเปลี่ยนส่งผลต่อการเทรดอย่างไร',
        paragraphs: [
          'เมื่ออัตราแลกเปลี่ยนเคลื่อนไหว ราคาคู่เงินก็เปลี่ยนตามไปด้วย สำหรับเทรดเดอร์ Forex ความผันผวนนี้คือโอกาสทำกำไร แต่ก็เป็นความเสี่ยงที่ต้องบริหารอย่างระมัดระวังเช่นกัน',
          'การติดตามว่าปัจจัยใดกำลังขับเคลื่อนค่าเงินอยู่ จะช่วยให้ตัดสินใจได้บนพื้นฐานของข้อมูลมากกว่าความคาดเดา',
        ],
        bullets: [
          'การเคลื่อนไหวของอัตราคือที่มาโดยตรงของกำไรขาดทุน',
          'ข่าวเศรษฐกิจสำคัญมักทำให้อัตราแกว่งแรง',
          'ควรใช้การบริหารความเสี่ยงควบคู่เสมอ',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'อัตราแลกเปลี่ยนกับราคาคู่เงินต่างกันไหม',
        a: 'จริง ๆ แล้วเป็นสิ่งเดียวกัน ราคาคู่เงินที่เราเห็นบนแพลตฟอร์มก็คืออัตราแลกเปลี่ยนระหว่างสองสกุลเงินนั่นเอง',
        a2: 'ตัวเลข 1.0850 บนหน้าจอคืออัตราแลกเปลี่ยนของ EUR ต่อ USD โดยตรง สื่อบางแห่งมักเขียนในมุมกลับ เช่น 0.9217 USD ต่อ 1 EUR ซึ่งเป็นค่าเดียวกันเพียงสลับด้าน',
      },
      {
        q: 'ทำไมอัตราแลกเปลี่ยนเปลี่ยนตลอดเวลา',
        a: 'เพราะถูกกำหนดจากอุปสงค์และอุปทานของสกุลเงินที่เปลี่ยนเรื่อย ๆ ตามข่าวเศรษฐกิจ ตัวเลขต่าง ๆ และกระแสการลงทุน',
        a2: 'ในหนึ่งวัน EUR/USD อาจขยับ 50-100 Pip จากข่าวเดียว เช่นตัวเลขการจ้างงานสหรัฐฯ ออกมาดีกว่าคาด เงินมักไหลเข้าดอลลาร์และกดให้ยูโรอ่อนลงทันที',
      },
      {
        q: 'อัตราดอกเบี้ยมีผลต่อค่าเงินอย่างไร',
        a: 'โดยทั่วไปอัตราดอกเบี้ยที่สูงขึ้นจะดึงดูดเงินทุนเข้าประเทศและหนุนค่าเงินให้แข็งค่าขึ้นเมื่อเทียบกับสกุลอื่น',
        a2: 'ถ้าเฟดขึ้นดอกเบี้ยจาก 5.25% เป็น 5.50% ขณะที่ ECB คงเดิม ส่วนต่างผลตอบแทนจะกว้างขึ้น นักลงทุนอาจย้ายเงินไปถือดอลลาร์มากขึ้น กดให้ EUR/USD ปรับตัวลง',
      },
    ],
    related: ['base-quote-currency', 'currency-pairs', 'how-forex-market-works'],
  },
  {
    slug: 'what-is-point',
    category: 'Forex พื้นฐาน',
    categorySlug: 'forex-basics',
    title: 'Point คืออะไร? ต่างจาก Pip อย่างไรในตลาด Forex',
    description:
      'Point คือหน่วยย่อยที่สุดของราคาในแพลตฟอร์มเทรด มาทำความเข้าใจว่า Point ต่างจาก Pip อย่างไร และทำไมต้องรู้จัก',
    readingTime: '6 นาที',
    updatedDate: '2026-09-16',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20forex%20point%20and%20pip%20concept%20teal%20decimal%20digit%20blocks%20with%20warm%20orange%20last%20digit%20highlight%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text&width=1200&height=675&seq=art-what-is-point-01&orientation=landscape',
    tags: ['Point', 'Pip', 'คำศัพท์'],
    intro: [
      'บนแพลตฟอร์มเทรด ราคาของคู่เงินมักแสดงทศนิยมหลายตำแหน่ง เราอาจเคยได้ยินทั้งคำว่า Pip และ Point ซึ่งดูคล้ายกันมากจนสับสน',
      'บทความนี้จะอธิบายว่า Point คืออะไร และมันสัมพันธ์กับ Pip อย่างไร เพื่อให้คุณอ่านตัวเลขบนหน้าจอได้อย่างถูกต้อง',
    ],
    sections: [
      {
        id: 'what-is-point',
        heading: 'Point คืออะไร',
        paragraphs: [
          'Point คือหน่วยการเปลี่ยนแปลงที่เล็กที่สุดของราคาที่แสดงบนแพลตฟอร์มเทรด เป็นทศนิยมตำแหน่งสุดท้ายที่ราคาสามารถขยับได้ เช่นถ้าราคาแสดงทศนิยม 5 ตำแหน่ง ตำแหน่งที่ 5 ก็คือ Point',
        ],
        bullets: [
          'เป็นหน่วยย่อยที่สุดของราคาที่แสดง',
          'อยู่ที่ทศนิยมตำแหน่งสุดท้ายบนแพลตฟอร์ม',
          'ใช้บอกความละเอียดของการเคลื่อนไหวราคา',
        ],
        steps: [],
      },
      {
        id: 'point-vs-pip',
        heading: 'Point กับ Pip ต่างกันอย่างไร',
        paragraphs: [
          'Pip คือหน่วยมาตรฐานที่ใช้บอกการเคลื่อนไหวของราคา ส่วน Point มักเป็นหนึ่งในสิบของ Pip หรือที่เรียกกันว่า Pipette ในแพลตฟอร์มที่แสดงทศนิยม 5 ตำแหน่ง',
          'ดังนั้นถ้าราคาเคลื่อน 1 Pip มักเท่ากับ 10 Point ซึ่งทำให้เทรดเดอร์เห็นการเคลื่อนไหวที่ละเอียดขึ้น',
        ],
        bullets: [
          'Pip คือหน่วยวัดหลักที่ใช้กันทั่วไป',
          'Point คือหนึ่งในสิบของ Pip (Pipette)',
          '1 Pip = 10 Point ในคู่เงินส่วนใหญ่',
        ],
        steps: [],
      },
      {
        id: 'counting',
        heading: 'นับ Point อย่างไรให้ถูกต้อง',
        paragraphs: [
          'การนับ Point ให้ดูที่ทศนิยมตำแหน่งสุดท้ายที่ราคาแสดงบนแพลตฟอร์มของคุณ สำหรับคู่เงินทั่วไปที่แสดง 5 ตำแหน่ง การขยับจาก 1.08420 เป็น 1.08421 คือ 1 Point',
        ],
        bullets: [
          'ดูทศนิยมตำแหน่งสุดท้ายบนหน้าจอ',
          'คู่เงินเยนมักแสดงทศนิยม 3 ตำแหน่ง',
          'จำนวนตำแหน่งที่แสดงขึ้นอยู่กับโบรกเกอร์และแพลตฟอร์ม',
        ],
        steps: [],
      },
      {
        id: 'why',
        heading: 'ทำไมต้องเข้าใจ Point',
        paragraphs: [
          'มือใหม่หลายคนสับสนเพราะอ่านค่าความเคลื่อนไหวผิดหน่วย ทำให้ประเมินกำไรขาดทุนหรือกำหนด Stop Loss คลาดเคลื่อน การเข้าใจว่าแพลตฟอร์มของเรานับเป็น Pip หรือ Point จึงช่วยให้คำนวณได้แม่นยำขึ้น',
          'คู่เงินที่แสดงราคา 5 หลักอย่าง EURUSD จะมี 1 Pip เท่ากับ 10 Point ดังนั้น Stop Loss 20 Pip ที่คุณตั้งใจคือ 200 Point ส่วนคู่เงินเยนที่แสดง 3 หลักอย่าง USDJPY จะมี 1 Pip = 10 Point เช่นกัน แต่ราคา 0.01 ในคู่เยนคือ 1 Pip ไม่ใช่ 1 Point ตรงจุดนี้ทำให้คนกรอกตัวเลขผิดกันบ่อยที่สุด',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Point กับ Pip อันไหนใหญ่กว่า',
        a: 'Pip ใหญ่กว่า โดยทั่วไป 1 Pip เท่ากับ 10 Point หรือที่เรียกว่า Pipette',
        a2: 'บน EUR/USD ที่แสดงทศนิยม 5 ตำแหน่ง การขยับจาก 1.08420 ไป 1.08430 คือ 1 Point หรือ 0.1 Pip ส่วนการขยับไป 1.08520 คือ 10 Point หรือ 1 Pip เต็ม',
      },
      {
        q: 'ทำไมบางแพลตฟอร์มแสดงทศนิยม 5 ตำแหน่ง',
        a: 'เพื่อให้เห็นการเคลื่อนไหวราคาที่ละเอียดขึ้น โดย 4 ตำแหน่งแรกคือ Pip และตำแหน่งที่ 5 คือ Point',
        a2: 'การแสดงละเอียดขึ้นช่วยให้เห็นส่วนต่างของ Spread ชัดเจน เช่น Spread 0.8 Pip จะแสดงเป็น 8 Point ถ้าเทรดบ่อย ตัวเลขระดับ Point นี้มีผลต่อต้นทุนรวมอย่างมีนัยสำคัญ',
      },
      {
        q: 'ต้องใช้ Point คำนวณกำไรไหม',
        a: 'โดยทั่วไปใช้นับ Pip เป็นหลักในการคำนวณกำไรขาดทุน แต่ Point ช่วยให้เห็นการขยับราคาที่ละเอียดขึ้น',
        a2: 'การคำนวณความเสี่ยงให้ใช้ Pip เป็นหลัก เพราะโบรกเกอร์และเครื่องคำนวณมาตรฐานอ้างอิงหน่วยนี้ ถ้าเห็นตัวเลขเป็น Point ให้หาร 10 ก่อน เช่น Stop Loss 250 Point = 25 Pip',
      },
    ],
    related: ['what-is-pip', 'what-is-lot', 'what-is-spread'],
  },
  {
    slug: 'what-is-lot',
    category: 'Forex พื้นฐาน',
    categorySlug: 'forex-basics',
    title: 'Lot คืออะไร? เข้าใจขนาดการเทรด Standard Mini และ Micro Lot',
    description:
      'Lot คือหน่วยวัดขนาดการเทรดในตลาด Forex มาทำความเข้าใจ Standard Mini และ Micro Lot พร้อมวิธีเลือกขนาดให้เหมาะกับพอร์ต',
    readingTime: '7 นาที',
    updatedDate: '2026-09-14',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20forex%20lot%20size%20concept%20teal%20stacked%20blocks%20of%20different%20heights%20with%20warm%20orange%20accent%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text%20no%20people&width=1200&height=675&seq=art-what-is-lot-01&orientation=landscape',
    tags: ['Lot', 'ขนาดการเทรด', 'คำศัพท์'],
    intro: [
      'Lot คือหน่วยที่ใช้บอกขนาดของการเปิดออเดอร์ในตลาด Forex เปรียบเสมือนการเลือกว่าจะซื้อสินค้าเป็นกล่องใหญ่หรือกล่องเล็ก ยิ่ง Lot ใหญ่ กำไรและขาดทุนต่อการเคลื่อนไหว 1 Pip ก็ยิ่งสูงขึ้น',
      'การเลือก Lot ให้เหมาะกับพอร์ตเป็นหัวใจของการบริหารความเสี่ยง บทความนี้จะพาคุณรู้จัก Lot แต่ละขนาดและวิธีเลือกใช้',
    ],
    sections: [
      {
        id: 'what-is-lot',
        heading: 'Lot คืออะไร',
        paragraphs: [
          'Lot คือหน่วยมาตรฐานที่ใช้วัดปริมาณการซื้อขายในตลาด Forex โดยปริมาณที่เปิดจะส่งผลโดยตรงต่อมูลค่าของ Pip และขนาดความเสี่ยงของพอร์ต',
        ],
        bullets: [
          'เป็นหน่วยวัดขนาดสถานะการเทรด',
          'Lot ยิ่งใหญ่ มูลค่าต่อ Pip ยิ่งสูง',
          'ใช้ควบคุมขนาดความเสี่ยงของแต่ละออเดอร์',
        ],
        steps: [],
      },
      {
        id: 'lot-sizes',
        heading: 'Standard Mini และ Micro Lot',
        paragraphs: [
          'ขนาด Lot ถูกแบ่งเป็นหลายระดับเพื่อให้เทรดเดอร์ทุกขนาดพอร์ตเลือกใช้ได้ เหมาะกับทั้งพอร์ตเล็กของมือใหม่และพอร์ตใหญ่ของมืออาชีพ',
        ],
        bullets: [
          'Standard Lot = 100,000 หน่วย',
          'Mini Lot = 10,000 หน่วย (0.10)',
          'Micro Lot = 1,000 หน่วย (0.01)',
        ],
        steps: [],
      },
      {
        id: 'position-sizing',
        heading: 'เลือกขนาด Lot อย่างไร',
        paragraphs: [
          'การเลือก Lot ที่ดีที่สุดไม่ได้ขึ้นอยู่กับความอยากทำกำไร แต่ขึ้นอยู่กับความเสี่ยงที่คุณรับได้ต่อออเดอร์ เมื่อเทียบกับระยะ Stop Loss มือใหม่ควรเริ่มจาก Micro Lot เพื่อฝึกฝนด้วยความเสี่ยงต่ำ',
        ],
        bullets: [
          'คำนวณขนาดจากความเสี่ยงต่อออเดอร์ที่รับได้',
          'ยิ่ง Stop Loss ไกล ยิ่งต้องลดขนาด Lot',
          'เริ่มจาก Micro Lot ก่อนเมื่อยังไม่มีประสบการณ์',
        ],
        steps: [],
      },
      {
        id: 'risk',
        heading: 'Lot กับความเสี่ยง',
        paragraphs: [
          'เพราะกำไรและขาดทุนขยายตามขนาด Lot การใช้ Lot ใหญ่เกินไปเมื่อเทียบกับพอร์ตจึงเสี่ยงทำให้พอร์ตถูกปิดออเดอร์เร็วขึ้น การกำหนด Lot ให้คงที่ตามแผนความเสี่ยงจะช่วยให้พอร์ตอยู่รอดในระยะยาว',
          'สเกลมาตรฐานคือ 1.00 Lot = 100,000 หน่วย ซึ่ง 1 Pip บน EURUSD เท่ากับ 10 ดอลลาร์, 0.10 Lot เท่ากับ 1 ดอลลาร์ และ 0.01 Lot เท่ากับ 0.10 ดอลลาร์ ถ้าพอร์ตมี 1,000 ดอลลาร์และรับความเสี่ยง 1% คือ 10 ดอลลาร์ การเปิด 0.10 Lot พร้อม Stop Loss 10 Pip ก็ใช้โควตาความเสี่ยงหมดพอดี' ,
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Standard Lot มีค่าเท่าไร',
        a: 'Standard Lot มีขนาด 100,000 หน่วยของสกุลเงินฐาน ซึ่งมักมีมูลค่าประมาณ 10 ดอลลาร์สหรัฐต่อ 1 Pip สำหรับคู่เงินส่วนใหญ่',
        a2: 'Lot ย่อยที่ใช้บ่อยคือ Mini Lot 0.10 (10,000 หน่วย), Micro Lot 0.01 (1,000 หน่วย) และ Nano Lot 0.001 ในบางโบรกเกอร์ ยิ่ง Lot เล็กลง ความเสี่ยงต่อ Pip ก็ลดลงตามสัดส่วน',
      },
      {
        q: 'มือใหม่ควรเริ่มที่ Lot เท่าไร',
        a: 'แนะนำให้เริ่มจาก Micro Lot (0.01) เพื่อฝึกฝนด้วยความเสี่ยงที่ต่ำ และค่อย ๆ ปรับเมื่อเข้าใจการบริหารความเสี่ยงแล้ว',
        a2: 'เช่นพอร์ต 500 ดอลลาร์ รับความเสี่ยง 1% = 5 ดอลลาร์ กับ Stop Loss 25 Pip บน EUR/USD จะได้ราว 0.02 lot ซึ่งเป็นขนาดที่เปิดได้จริงและขาดทุนไม่เกินแผน',
      },
      {
        q: 'Lot ใหญ่ทำให้กำไรมากขึ้นไหม',
        a: 'ทำให้กำไรต่อ Pip มากขึ้นจริง แต่ก็ทำให้ขาดทุนต่อ Pip มากขึ้นเท่ากัน ความเสี่ยงจึงขึ้นอยู่กับขนาด Lot ที่เลือกด้วย',
        a2: '0.01 lot บน EUR/USD ให้ผลราว 0.1 ดอลลาร์ต่อ Pip ส่วน 1.00 lot ให้ 10 ดอลลาร์ต่อ Pip ต่างกัน 100 เท่าทั้งกำไรและขาดทุน จึงควรกำหนด Lot จากความเสี่ยง ไม่ใช่จากความอยากได้กำไร',
      },
    ],
    related: ['what-is-pip', 'what-is-point', 'what-is-leverage'],
  },
  {
    slug: 'what-is-commission',
    category: 'Forex พื้นฐาน',
    categorySlug: 'forex-basics',
    title: 'Commission คืออะไร? ค่าธรรมเนียมการเทรดที่ต้องเข้าใจ',
    description:
      'Commission คือค่าธรรมเนียมที่โบรกเกอร์คิดต่อปริมาณเทรด มาทำความเข้าใจว่ามันต่างจาก Spread อย่างไร และคำนวณต้นทุนอย่างไรให้ครบ',
    readingTime: '6 นาที',
    updatedDate: '2026-09-11',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20forex%20commission%20fee%20concept%20teal%20receipt%20shape%20with%20warm%20orange%20percent%20mark%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text%20no%20people&width=1200&height=675&seq=art-what-is-commission-01&orientation=landscape',
    tags: ['Commission', 'ต้นทุน', 'คำศัพท์'],
    intro: [
      'นอกจาก Spread แล้ว เทรดเดอร์บางคนต้องจ่าย Commission หรือค่าธรรมเนียมการเทรดเพิ่มด้วย โดยเฉพาะบัญชีที่เน้น Spread ต่ำ ค่าธรรมเนียมนี้จึงกลายเป็นต้นทุนส่วนสำคัญที่ต้องคิดให้ครบ',
      'บทความนี้จะอธิบายว่า Commission คืออะไร ต่างจาก Spread อย่างไร และคำนวณต้นทุนรวมอย่างไรให้มองเห็นภาพจริง',
    ],
    sections: [
      {
        id: 'what-is-commission',
        heading: 'Commission คืออะไร',
        paragraphs: [
          'Commission คือค่าธรรมเนียมที่โบรกเกอร์เรียกเก็บเพิ่มจากการเทรด คิดเป็นจำนวนเงินต่อปริมาณที่เทรด (ต่อ Lot) โดยมักถูกคิดทั้งขาเปิดและขาปิดออเดอร์',
        ],
        bullets: [
          'คิดตามปริมาณที่เทรดต่อล็อต',
          'มักเก็บทั้งตอนเปิดและตอนปิดออเดอร์',
          'มักพบบนบัญชีที่ให้ Spread ต่ำ',
        ],
        steps: [],
      },
      {
        id: 'vs-spread',
        heading: 'Commission ต่างจาก Spread อย่างไร',
        paragraphs: [
          'Spread คือต้นทุนที่แฝงอยู่ในส่วนต่างราคา Bid และ Ask ซึ่งเทรดเดอร์มองไม่เห็นเป็นค่าธรรมเนียมตรง ๆ ส่วน Commission คือค่าธรรมเนียมที่ถูกคิดแยกออกมาอย่างชัดเจน',
          'บัญชีที่มี Spread ต่ำมากมักชดเชยรายได้ด้วย Commission ส่วนบัญชีที่ไม่มี Commission จะมี Spread ที่กว้างกว่าแทน',
        ],
        bullets: [
          'Spread คือต้นทุนแฝงในส่วนต่างราคา',
          'Commission คือค่าธรรมเนียมที่ถูกคิดแยก',
          'Spread ต่ำมักมาพร้อม Commission',
        ],
        steps: [],
      },
      {
        id: 'models',
        heading: 'บัญชีแบบ Spread อย่างเดียว และแบบมี Commission',
        paragraphs: [
          'โบรกเกอร์มักมีบัญชีให้เลือกสองรูปแบบหลัก คือบัญชีที่คิดเฉพาะ Spread และบัญชีที่ Spread ต่ำมากแต่มี Commission เพิ่มมา การเลือกควรดูต้นทุนรวมต่อออเดอร์เป็นหลัก ไม่ใช่ดูเพียงตัวใดตัวหนึ่ง',
        ],
        bullets: [
          'บัญชี Standard มักไม่คิด Commission แต่ Spread กว้างกว่า',
          'บัญชี Raw หรือ ECN มักมี Spread ต่ำแต่มี Commission',
          'เปรียบเทียบต้นทุนรวมจึงจะเห็นภาพจริง',
        ],
        steps: [],
      },
      {
        id: 'calculate',
        heading: 'คำนวณ Commission อย่างไร',
        paragraphs: [
          'หากโบรกเกอร์คิด Commission 7 ดอลลาร์สหรัฐต่อ Standard Lot ต่อรอบ การเปิดและปิด 1 Standard Lot จะมีต้นทุนค่าธรรมเนียมรวมเท่ากับทั้งขาเปิดและขาปิด รวมกับ Spread ที่เกิดขึ้นในออเดอร์นั้น',
        ],
        bullets: [
          'อ่านอัตรา Commission จากเงื่อนไขของโบรกเกอร์',
          'อย่าลืมคิดทั้งขาเปิดและขาปิด',
          'นำ Spread มาบวกรวมเพื่อดูต้นทุนรวมต่อออเดอร์',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Commission คิดตอนไหน',
        a: 'โดยทั่วไปจะถูกคิดทั้งตอนเปิดออเดอร์และตอนปิดออเดอร์ ตามปริมาณล็อตที่เทรด',
        a2: 'เช่นค่าคอมมิชชั่น 7 ดอลลาร์ต่อ Lot ต่อรอบ จะถูกหักราว 3.5 ดอลลาร์ตอนเปิด และ 3.5 ดอลลาร์ตอนปิด จึงควรนับเป็นต้นทุนทุกครั้งที่เข้าและออก',
      },
      {
        q: 'บัญชีที่มี Commission ดีกว่าหรือไม่',
        a: 'ขึ้นอยู่กับสไตล์การเทรด ถ้าเทรดบ่อยและใช้ล็อตใหญ่ บัญชี Spread ต่ำที่มี Commission อาจถูกกว่า แต่ต้องคำนวณต้นทุนรวมจริงก่อนตัดสินใจ',
        a2: 'ถ้าเทรดเพียง 0.01-0.05 lot สัปดาห์ละไม่กี่ไม้ บัญชี Standard ที่ไม่มีค่าคอมมิชชั่นมักคุ้มกว่า แต่ถ้าเทรด 1 lot ขึ้นไปหลายไม้ต่อวัน ส่วนต่าง Spread ที่ลดลงมักมากกว่าค่าคอมมิชชั่นที่จ่าย',
      },
      {
        q: 'ทำไมบางโบรกเกอร์ไม่คิด Commission',
        a: 'เพราะโบรกเกอร์เหล่านี้เก็บรายได้จาก Spread ที่กว้างกว่าแทน จึงไม่เก็บค่าธรรมเนียมแยกเป็น Commission',
        a2: 'โมเดลนี้เรียกว่า Spread Markup โบรกเกอร์บวกส่วนต่างเข้ากับ Spread จากผู้ให้บริการสภาพคล่อง เช่นต้นทุนจริง 0.3 Pip แต่เสนอ 1.2 Pip ต้นทุนของคุณจึงอยู่ในรูป Spread แทน',
      },
    ],
    related: ['what-is-spread', 'bid-and-ask', 'what-is-lot'],
  },
  {
    slug: 'free-margin',
    category: 'Leverage และ Margin',
    categorySlug: 'forex-basics',
    title: 'Free Margin คืออะไร? เข้าใจเงินที่เหลือใช้เปิดออเดอร์ใหม่',
    description:
      'Free Margin คือเงินในพอร์ตที่ยังเหลือและนำไปใช้เปิดออเดอร์ใหม่ได้ มาทำความเข้าใจวิธีคำนวณ และทำไมมันสำคัญต่อการบริหารความเสี่ยง',
    readingTime: '7 นาที',
    updatedDate: '2026-09-09',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20forex%20free%20margin%20concept%20teal%20wallet%20with%20a%20warm%20orange%20reserved%20portion%20split%20apart%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text%20no%20people&width=1200&height=675&seq=art-free-margin-01&orientation=landscape',
    tags: ['Free Margin', 'Margin', 'ความเสี่ยง'],
    intro: [
      'Free Margin คือเงินในพอร์ตที่ยังเหลือและยังไม่ถูกกันไว้เป็นหลักประกัน จึงสามารถนำไปใช้เปิดออเดอร์ใหม่หรือรองรับการขาดทุนลอยตัวได้',
      'การรู้ว่าเรามี Free Margin เหลือเท่าไร จะช่วยให้วางแผนเปิดออเดอร์และควบคุมความเสี่ยงได้อย่างมีสติมากขึ้น',
    ],
    sections: [
      {
        id: 'what-is-free-margin',
        heading: 'Free Margin คืออะไร',
        paragraphs: [
          'Free Margin คือส่วนของ Equity ที่ไม่ได้ถูกกันไว้เป็น Required Margin สำหรับออเดอร์ที่เปิดอยู่ มันคือพื้นที่ว่างของพอร์ตที่เรายังใช้เปิดสถานะใหม่ได้ หรือใช้รองรับกำไรขาดทุนที่แกว่งไปมา',
          'ถ้า Free Margin เหลือน้อย แปลว่าพอร์ตเราตึงตัวมาก การเปิดออเดอร์เพิ่มจะยิ่งเพิ่มความเสี่ยงที่อาจถูก Margin Call ได้ง่ายขึ้น',
        ],
        bullets: [
          'คำนวณจาก Equity ลบด้วย Required Margin',
          'เป็นเงินที่ยังใช้เปิดออเดอร์ใหม่ได้',
          'ยิ่งเหลือน้อย พอร์ตยิ่งตึงตัวและเสี่ยง',
        ],
        steps: [],
      },
      {
        id: 'how-to-calculate',
        heading: 'คำนวณ Free Margin อย่างไร',
        paragraphs: [
          'สูตรพื้นฐานคือ Free Margin = Equity − Margin ที่ใช้อยู่ โดย Equity คือยอดเงินในพอร์ตรวมกำไรขาดทุนลอยตัว ส่วน Margin คือเงินประกันที่ถูกกันไว้สำหรับออเดอร์ที่เปิดอยู่',
          'สมมติ Equity อยู่ที่ 1,000 ดอลลาร์สหรัฐ และมี Required Margin ใช้ไป 200 ดอลลาร์สหรัฐ Free Margin จะเหลือ 800 ดอลลาร์สหรัฐสำหรับรองรับความผันผวนหรือเปิดออเดอร์ใหม่',
        ],
        bullets: [
          'Free Margin = Equity − Used Margin',
          'Equity เปลี่ยนแปลงตามกำไรขาดทุนลอยตัว',
          'กำไรลอยตัวช่วยเพิ่ม Free Margin อัตโนมัติ',
        ],
        steps: [],
      },
      {
        id: 'equity-vs-balance',
        heading: 'Balance, Equity และ Free Margin ต่างกันอย่างไร',
        paragraphs: [
          'มือใหม่มักสับสนสามคำนี้ Balance คือยอดเงินคงเหลือที่ยังไม่รวมกำไรขาดทุนลอยตัวของออเดอร์ที่เปิดอยู่ ส่วน Equity คือมูลค่าพอร์ตจริงที่คำนวณกำไรขาดทุนลอยตัวเข้าไปแล้ว และ Free Margin คือ Equity ที่ยังไม่ถูกกันเป็นหลักประกัน',
          'การแยกให้ออกจะช่วยให้อ่านตัวเลขบนแพลตฟอร์มเทรดได้ถูกต้อง และรู้ว่าพอร์ตเรามีพื้นที่เหลือจริงเท่าไร',
        ],
        bullets: [
          'Balance = ยอดเงินหลังปิดออเดอร์ล่าสุด',
          'Equity = Balance ± กำไรขาดทุนลอยตัว',
          'Free Margin = Equity − Used Margin',
        ],
        steps: [],
      },
      {
        id: 'manage',
        heading: 'บริหาร Free Margin อย่างไรให้ปลอดภัย',
        paragraphs: [
          'เป้าหมายไม่ใช่ใช้ Free Margin ให้หมด แต่เป็นการเหลือพื้นที่ไว้รองรับความผันผวนเสมอ เปิดออเดอร์ด้วยขนาดที่พอเหมาะและไม่เปิดหลายออเดอร์พร้อมกันจนพอร์ตตึงเกินไป',
          'การตั้ง Stop Loss ทุกออเดอร์และการควบคุมขนาดสถานะตามความเสี่ยงที่รับได้ จะช่วยให้ Free Margin ของคุณไม่ถูกกัดกร่อนเร็วเกินไป',
        ],
        bullets: [
          'อย่าเปิดออเดอร์จน Free Margin เหลือน้อย',
          'ตั้ง Stop Loss ทุกครั้งเพื่อจำกัดการกัดกร่อนของพอร์ต',
          'เริ่มจากขนาดออเดอร์เล็กเพื่อดูพฤติกรรมพอร์ตก่อน',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Free Margin กับ Equity ต่างกันอย่างไร',
        a: 'Equity คือมูลค่าพอร์ตรวมที่คิดกำไรขาดทุนลอยตัวแล้ว ส่วน Free Margin คือ Equity ที่หักเงินประกันที่ใช้อยู่แล้ว จึงเป็นเงินที่ยังใช้เปิดออเดอร์ใหม่ได้',
        a2: 'เช่นพอร์ต 2,000 ดอลลาร์มีกำไรลอยตัว 150 ดอลลาร์ จะได้ Equity 2,150 ดอลลาร์ ถ้าใช้ Margin อยู่ 500 ดอลลาร์ Free Margin จะเหลือ 1,650 ดอลลาร์',
      },
      {
        q: 'Free Margin เหลือ 0 เกิดอะไรขึ้น',
        a: 'แปลว่าพอร์ตถูกใช้เป็นหลักประกันจนเต็ม ไม่มีพื้นที่รับความผันผวนเพิ่ม และเสี่ยงถูกเรียก Margin Call หรือปิดออเดอร์อัตโนมัติได้',
        a2: 'เมื่อ Margin Level ร่วงถึงเกณฑ์ของโบรกเกอร์ เช่น 50% ระบบจะปิดออเดอร์ที่ขาดทุนมากที่สุดก่อนทีละไม้ จนกว่า Margin Level จะกลับมาอยู่ในระดับที่กำหนด',
      },
      {
        q: 'ทำไมกำไรลอยตัวทำให้ Free Margin เพิ่มขึ้น',
        a: 'เพราะกำไรลอยตัวจะถูกนับเข้าไปใน Equity เมื่อ Equity สูงขึ้น Free Margin ซึ่งเป็น Equity ลบ Margin ที่ใช้อยู่ก็จะสูงตามไปด้วย',
        a2: 'กลับกัน ถ้าขาดทุนลอยตัว 150 ดอลลาร์ Equity จะลดลงเหลือ 1,850 ดอลลาร์ และ Free Margin ลดตามทันที นี่คือเหตุผลที่ไม้ที่กำลังแพ้ทำให้เปิดไม้อื่นไม่ได้แม้ยังไม่ปิดขาดทุน',
      },
    ],
    related: ['what-is-margin', 'margin-level', 'what-is-leverage'],
  },
  {
    slug: 'margin-level',
    category: 'Leverage และ Margin',
    categorySlug: 'forex-basics',
    title: 'Margin Level คืออะไร? ตัวเลขบอกสุขภาพพอร์ตของคุณ',
    description:
      'Margin Level คืออัตราส่วนที่บอกว่าพอร์ตปลอดภัยแค่ไหน มาทำความเข้าใจวิธีคำนวณ และระดับที่โบรกเกอร์มักใช้เตือนหรือปิดออเดอร์',
    readingTime: '7 นาที',
    updatedDate: '2026-09-07',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20forex%20margin%20level%20gauge%20concept%20teal%20gauge%20meter%20with%20warm%20orange%20warning%20zone%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text%20no%20people&width=1200&height=675&seq=art-margin-level-01&orientation=landscape',
    tags: ['Margin Level', 'Margin', 'ความเสี่ยง'],
    intro: [
      'Margin Level คือตัวเลขเปอร์เซ็นต์ที่บอกว่าพอร์ตของเรามีเงินประกันเหลือพอหรือตึงตัวแค่ไหน ยิ่งตัวเลขสูง พอร์ตยิ่งปลอดภัย',
      'เทรดเดอร์ที่เข้าใจ Margin Level จะรู้ล่วงหน้าว่าเมื่อไรพอร์ตเข้าใกล้โซนอันตราย ก่อนที่โบรกเกอร์จะเรียก Margin Call',
    ],
    sections: [
      {
        id: 'what-is-margin-level',
        heading: 'Margin Level คืออะไร',
        paragraphs: [
          'Margin Level คืออัตราส่วนระหว่าง Equity กับ Margin ที่ใช้อยู่ แสดงออกมาเป็นเปอร์เซ็นต์ เป็นตัวชี้วัดสุขภาพพอร์ตที่ตรงไปตรงมาที่สุดบนแพลตฟอร์มเทรด',
          'เมื่อ Equity สูงเมื่อเทียบกับ Margin ที่ใช้อยู่ Margin Level จะสูง แปลว่ามีพื้นที่รองรับความผันผวนมาก แต่ถ้า Equity ลดลงเรื่อย ๆ Margin Level จะต่ำลงจนเข้าสู่โซนเสี่ยง',
        ],
        bullets: [
          'แสดงเป็นเปอร์เซ็นต์บนแพลตฟอร์มเทรด',
          'ยิ่งสูงยิ่งปลอดภัย',
          'ยิ่งต่ำยิ่งใกล้ถูกเตือนหรือปิดออเดอร์',
        ],
        steps: [],
      },
      {
        id: 'how-to-calculate',
        heading: 'คำนวณ Margin Level อย่างไร',
        paragraphs: [
          'สูตรคือ Margin Level = (Equity ÷ Used Margin) × 100 ตัวอย่างเช่น Equity 1,000 ดอลลาร์สหรัฐ และ Margin ที่ใช้ 200 ดอลลาร์สหรัฐ จะได้ Margin Level เท่ากับ 500%',
          'เมื่อเปิดออเดอร์เพิ่ม Margin ที่ใช้จะสูงขึ้นจากตัวหารที่ใหญ่ขึ้น จึงทำให้ Margin Level ลดลงทันทีแม้จำนวน Equity เท่าเดิม นี่คือเหตุผลที่เปิดออเดอร์หลายตัวพร้อมกันจะกด Margin Level ให้ต่ำลงอย่างรวดเร็ว',
        ],
        bullets: [
          'Margin Level = (Equity ÷ Used Margin) × 100',
          'เปิดออเดอร์เพิ่มทำให้ Margin ที่ใช้สูงขึ้น',
          'ขาดทุนลอยตัวสูงขึ้นทำให้ Margin Level ต่ำลง',
        ],
        steps: [],
      },
      {
        id: 'levels',
        heading: 'ระดับ Margin Level ที่ควรระวัง',
        paragraphs: [
          'โบรกเกอร์แต่ละแห่งกำหนดเกณฑ์ต่างกัน แต่โดยทั่วไปจะเริ่มเตือนที่ระดับประมาณ 100% และเริ่มปิดออเดอร์อัตโนมัติ (Stop Out) ที่ระดับต่ำกว่านั้น เช่น 50% หรือ 20%',
          'ดังนั้นหากคุณเห็น Margin Level ของตัวเองลดลงต่ำกว่า 100% ควรลดขนาดสถานะหรือเติมเงินทันที เพราะเหลือพื้นที่รับความผันผวนน้อยมากแล้ว',
        ],
        bullets: [
          'ประมาณ 100% = ระดับเริ่มเตือน (Margin Call)',
          'ต่ำกว่า 100% เรื่อย ๆ = โซนอันตราย',
          'ต่ำกว่าเกณฑ์ Stop Out = ถูกปิดออเดอร์อัตโนมัติ',
        ],
        steps: [],
      },
      {
        id: 'keep-safe',
        heading: 'รักษา Margin Level ให้ปลอดภัย',
        paragraphs: [
          'วิธีที่ดีที่สุดคืออย่าให้ Margin Level ตึงตัวตั้งแต่แรก ควบคุมขนาดออเดอร์ให้เล็กเมื่อเทียบกับ Equity และหลีกเลี่ยงการเปิดหลายออเดอร์ที่ทิศทางเดียวกันพร้อมกัน',
          'การตั้ง Stop Loss ทุกออเดอร์ยังช่วยจำกัดการกัดกร่อนของ Equity ซึ่งจะส่งผลโดยตรงต่อการรักษา Margin Level ไม่ให้ร่วงลงเร็วเกินไป',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Margin Level เท่าไรถือว่าปลอดภัย',
        a: 'ยิ่งสูงยิ่งปลอดภัย โดยทั่วไปควรอยู่ที่ระดับมากกว่า 200-300% ขึ้นไปเพื่อให้มีพื้นที่รองรับความผันผวน แต่เกณฑ์จริงขึ้นอยู่กับนโยบายของแต่ละโบรกเกอร์',
        a2: 'ถ้า Equity 2,000 ดอลลาร์และใช้ Margin 500 ดอลลาร์ จะได้ Margin Level 400% ซึ่งมีพื้นที่รับการขาดทุนลอยตัวได้ถึง 1,500 ดอลลาร์ก่อนแตะเกณฑ์ Margin Call ที่ 100% ในโบรกเกอร์ส่วนใหญ่',
      },
      {
        q: 'ทำไม Margin Level ลดลงทั้งที่ยังไม่ขาดทุน',
        a: 'เพราะการเปิดออเดอร์เพิ่มจะเพิ่ม Margin ที่ใช้เป็นตัวหาร เมื่อตัวหารสูงขึ้น Margin Level จึงลดลงแม้ Equity จะเท่าเดิม',
        a2: 'เช่น Equity 1,000 ดอลลาร์ใช้ Margin 200 ดอลลาร์ ได้ 500% ถ้าเปิดออเดอร์ใหม่จน Margin รวมเป็น 500 ดอลลาร์ ตัวเลขจะเหลือ 200% ทันที แม้เงินในพอร์ตจะเท่าเดิม',
      },
      {
        q: 'Margin Level กับ Free Margin เกี่ยวกันไหม',
        a: 'เกี่ยวข้องกัน เพราะทั้งคู่คำนวณจาก Equity และ Margin ที่ใช้อยู่ โดย Free Margin คือส่วนที่เหลือ ส่วน Margin Level คืออัตราส่วนที่บอกความปลอดภัยของทั้งพอร์ต',
        a2: 'Free Margin บอกจำนวนเงินที่ยังใช้ได้เป็นตัวเลขเดียว ส่วน Margin Level บอกเป็นเปอร์เซ็นต์ว่าพอร์ตเหลือกันชนมากน้อยแค่ไหน ทั้งสองจึงอ่านคู่กันเสมอเมื่อมีออเดอร์เปิดอยู่',
      },
    ],
    related: ['free-margin', 'margin-call-and-stop-out', 'what-is-margin'],
  },
  {
    slug: 'margin-call-and-stop-out',
    category: 'Leverage และ Margin',
    categorySlug: 'forex-basics',
    title: 'Margin Call และ Stop Out คืออะไร? เข้าใจก่อนพอร์ตถูกปิดออเดอร์',
    description:
      'Margin Call คือสัญญาณเตือน และ Stop Out คือการปิดออเดอร์อัตโนมัติ มาทำความเข้าใจว่าทั้งสองต่างกันอย่างไร และทำไม Stop Loss จึงสำคัญ',
    readingTime: '8 นาที',
    updatedDate: '2026-09-05',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20forex%20margin%20call%20concept%20teal%20warning%20triangle%20with%20warm%20orange%20alert%20line%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text%20no%20people&width=1200&height=675&seq=art-margin-call-01&orientation=landscape',
    tags: ['Margin Call', 'Stop Out', 'ความเสี่ยง'],
    intro: [
      'เมื่อพอร์ตขาดทุนสะสมมากพอจน Margin Level ลดต่ำลง โบรกเกอร์จะเริ่มเข้ามาเกี่ยวข้องกับออเดอร์ของเราในสองรูปแบบ คือแจ้งเตือนด้วย Margin Call และปิดออเดอร์ให้อัตโนมัติด้วย Stop Out',
      'บทความนี้จะอธิบายว่าทั้งสองคืออะไร ต่างกันอย่างไร และเราจะป้องกันไม่ให้พอร์ตไปถึงจุดนั้นได้อย่างไร',
    ],
    sections: [
      {
        id: 'what-is-margin-call',
        heading: 'Margin Call คืออะไร',
        paragraphs: [
          'Margin Call คือการแจ้งเตือนจากโบรกเกอร์ว่า Equity ของพอร์ตได้ลดต่ำลงถึงเกณฑ์ที่กำหนดเมื่อเทียบกับ Margin ที่ใช้อยู่ ในอดีตจะมาในรูปแบบการขอให้ลูกค้าเติมเงินเพื่อรักษาสถานะ',
          'ในแพลตฟอร์มออนไลน์ปัจจุบัน Margin Call มักปรากฏเป็นตัวเลข Margin Level ที่เปลี่ยนเป็นสีเตือน ไม่ได้โทรเรียกให้เติมเงินเหมือนแต่ก่อน แต่ก็เป็นสัญญาณว่าพอร์ตเริ่มตึงตัว',
        ],
        bullets: [
          'เป็นสัญญาณเตือนว่า Equity ลดต่ำกว่าเกณฑ์',
          'มักเกิดเมื่อ Margin Level ลงมาประมาณ 100%',
          'เรายังสามารถเลือกปิดออเดอร์หรือลดขนาดเองได้',
        ],
        steps: [],
      },
      {
        id: 'what-is-stop-out',
        heading: 'Stop Out คืออะไร',
        paragraphs: [
          'Stop Out คือการที่โบรกเกอร์บังคับปิดออเดอร์ของเราอัตโนมัติเมื่อ Margin Level ลดต่ำลงถึงเกณฑ์วิกฤตที่กำหนดไว้ มักจะต่ำกว่าเกณฑ์ Margin Call มาก เช่นที่ 50% หรือ 20%',
          'เมื่อถึงจุดนั้นเราไม่มีโอกาสเลือกเอง โบรกเกอร์จะปิดออเดอร์ที่ขาดทุนมากที่สุดก่อน จนกว่า Margin Level จะกลับมาอยู่ในระดับที่ปลอดภัย',
        ],
        bullets: [
          'เป็นการปิดออเดอร์อัตโนมัติที่เราควบคุมไม่ได้',
          'จะเริ่มปิดออเดอร์ที่ขาดทุนมากที่สุดก่อน',
          'เกิดขึ้นเมื่อ Margin Level ลงต่ำกว่าเกณฑ์ที่โบรกเกอร์กำหนด',
        ],
        steps: [],
      },
      {
        id: 'difference',
        heading: 'Margin Call กับ Stop Out ต่างกันอย่างไร',
        paragraphs: [
          'หัวใจที่ต่างกันคือลำดับเหตุการณ์และอำนาจตัดสินใจ Margin Call คือการเตือนว่าใกล้ถึงโซนอันตราย ยังเปิดโอกาสให้เราแก้ไขด้วยตัวเอง ส่วน Stop Out คือการลงมือของผู้ให้บริการเมื่อเราปล่อยให้พอร์ตตึงเกินไปแล้ว',
          'จำง่าย ๆ ว่า Margin Call คือสัญญาณไฟเหลืองที่ยังเลือกเองได้ และ Stop Out คือไฟแดงที่ระบบลงมือปิดออเดอร์ให้ทันที',
        ],
        bullets: [
          'Margin Call = เตือน เราแก้เองได้',
          'Stop Out = ระบบปิดออเดอร์ เราเลือกไม่ได้',
          'เกณฑ์ Stop Out มักต่ำกว่าเกณฑ์ Margin Call',
        ],
        steps: [],
      },
      {
        id: 'prevent',
        heading: 'ป้องกันไม่ให้ถึงจุด Margin Call และ Stop Out',
        paragraphs: [
          'วิธีป้องกันที่มีประสิทธิภาพที่สุดไม่ใช่การเติมเงินแก้ปัญหา แต่เป็นการไม่ปล่อยให้ Margin Level ตึงตัวตั้งแต่แรก ควบคุมขนาดออเดอร์ หลีกเลี่ยงการเปิดสถานะใหญ่เกินพอร์ต และไม่เปิดหลายออเดอร์ที่ทิศทางเดียวกันพร้อมกัน',
          'การตั้ง Stop Loss ทุกออเดอร์คือเกราะป้องกันที่สำคัญที่สุด เพราะมันจำกัดการขาดทุนให้อยู่ในระดับที่พอร์ตรับได้ ก่อนที่โบรกเกอร์จะต้องเข้ามาจัดการแทนเราด้วย Stop Out',
        ],
        bullets: [
          'ใช้ขนาดออเดอร์เล็กเมื่อเทียบกับ Equity',
          'ตั้ง Stop Loss ทุกออเดอร์เพื่อจำกัดการขาดทุน',
          'ตามดู Margin Level สม่ำเสมอโดยเฉพาะช่วงข่าวใหญ่',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Margin Call กับ Stop Out อันไหนรุนแรงกว่า',
        a: 'Stop Out รุนแรงกว่า เพราะเป็นการบังคับปิดออเดอร์อัตโนมัติที่เราเลือกเองไม่ได้ ส่วน Margin Call เพียงเป็นสัญญาณเตือนที่เรายังแก้ไขได้',
        a2: 'Margin Call มักเกิดที่ระดับ 100% ของ Margin Level ซึ่งยังแก้ได้ด้วยการเติมเงินหรือปิดบางไม้ ส่วน Stop Out ที่ระดับ 50% หรือต่ำกว่าคือระบบเริ่มบังคับปิดออเดอร์แทนเรา',
      },
      {
        q: 'Margin Call มาแล้วยังเปิดออเดอร์ได้ไหม',
        a: 'โดยทั่วไปทำไม่ได้หรือทำได้จำกัด เพราะเมื่อ Margin Level ต่ำ เรามี Free Margin เหลือน้อยมาก โบรกเกอร์ส่วนใหญ่มักไม่อนุญาตให้เปิดออเดอร์ใหม่ในสภาวะนี้',
        a2: 'แม้ระบบอนุญาตในบางกรณี การเปิดเพิ่มจะทำให้ Margin ที่ใช้สูงขึ้นและ Margin Level ลดลงเร็วขึ้น ซึ่งเร่งให้ถึงจุด Stop Out ทางที่ดีคือปิดไม้ที่ขาดทุนมากที่สุดก่อน',
      },
      {
        q: 'ตั้ง Stop Loss ช่วยป้องกัน Stop Out ได้ไหม',
        a: 'ช่วยได้มาก เพราะ Stop Loss จะปิดออเดอร์ที่ขาดทุนก่อนที่ Equity จะถูกกัดกร่อนจน Margin Level ร่วงถึงเกณฑ์ Stop Out ที่โบรกเกอร์กำหนด',
        a2: 'เช่นพอร์ต 1,000 ดอลลาร์เปิด 0.10 lot พร้อม Stop Loss 30 Pip จะขาดทุนสูงสุดราว 30 ดอลลาร์ หรือ 3% ของพอร์ต ซึ่งยังห่างจากจุดที่ Margin Level จะร่วงถึงเกณฑ์มาก',
      },
    ],
    related: ['margin-level', 'free-margin', 'high-leverage-risk'],
  },
  {
    slug: 'forex-profit-and-loss',
    category: 'กำไร ขาดทุน และต้นทุน',
    categorySlug: 'forex-basics',
    title: 'กำไรและขาดทุนจาก Forex คำนวณอย่างไร? เข้าใจทีละขั้น',
    description:
      'อธิบายวิธีคำนวณกำไรขาดทุนในตลาด Forex ตั้งแต่การอ่าน Pip มูลค่าต่อ Pip ไปจนถึงผลลัพธ์จริงในพอร์ต พร้อมตัวอย่างที่เข้าใจง่าย',
    readingTime: '8 นาที',
    updatedDate: '2026-09-08',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20forex%20profit%20and%20loss%20concept%20teal%20upward%20and%20downward%20arrows%20balance%20with%20warm%20orange%20marker%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text%20no%20people&width=1200&height=675&seq=art-forex-profit-and-loss-01&orientation=landscape',
    tags: ['กำไร', 'ขาดทุน', 'พื้นฐาน'],
    intro: [
      'การรู้ว่าออเดอร์หนึ่งทําำไรหรือขาดทุนเท่าไร ไม่ได้เกิดจากการเดา แตคํานวณได้จากความต่างของราคา มูลค่าต่อ Pip และขนาดล็อตที่ใช้',
      'บทความนี้จะพาคุณค่อย ๆ คํานวณกำไรขาดทุนทีละขั้น ด้วยตัวอย่างที่เข้าใจง่าย เพื่อให้เห็นวาตัวเลขในพอร์ตมาจากไหน',
    ],
    sections: [
      {
        id: 'basis',
        heading: 'กำไรขาดทุนคำนวณจากอะไร',
        paragraphs: [
          'กำไรหรือขาดทุนในตลาด Forex เกิดจากส่วนต่างระหว่างราคาที่เราเปิดออเดอร์กับราคาที่เราปิดออเดอร์ ถ้าเราซื้อแล้วราคาสูงขึ้นก็ได้กำไร ถ้าซื้อแล้วราคาลดลงก็ขาดทุน',
          'ขนาดของกำไรขาดทุนนั้นยังขึ้นอยู่กับจำนวน Pip ที่ราคาเคลื่อนที่ มูลค่าต่อ Pip ของคู่เงิน และขนาดล็อตที่เราใช้ทั้งสามอย่างจะคูณกันออกมาเป็นผลลัพธ์จริง',
        ],
        bullets: [
          'กำไรขาดทุนมาจากส่วนต่างราคาเปิดและปิด',
          'จำนวน Pip ที่เคลื่อนที่มีผลโดยตรง',
          'ขนาดล็อตเป็นตัวขยายผลลัพธ์',
        ],
        steps: [],
      },
      {
        id: 'value-per-pip',
        heading: 'หามูลค่าต่อ Pip ก่อน',
        paragraphs: [
          'ก้าวแรกของการคํานวณคือรู้ก่อนว่า 1 Pip ของคู่เงินที่เราซื้อขายมีมูลค่าเท่าไร โดยทั่วไป 1 Pip ต่อ 1 Standard Lot อยู่ที่ประมาณ 10 ดอลลาร์สหรัฐ ถ้าใช้ Mini Lot ก็จะลดลงตามสัดส่วน',
          'เมื่อรู้มูลค่าต่อ Pip และรู้ว่าตลาดเคลื่อนไปกี่ Pip แล้ว เราก็สามารถคูณออกมาเป็นกำไรขาดทุนเป็นเงินได้ทันที',
        ],
        bullets: [
          'Standard Lot (1.00) ≈ 10 USD ต่อ Pip',
          'Mini Lot (0.10) ≈ 1 USD ต่อ Pip',
          'Micro Lot (0.01) ≈ 0.1 USD ต่อ Pip',
        ],
        steps: [],
      },
      {
        id: 'example',
        heading: 'ตัวอย่างการคำนวณ',
        paragraphs: [
          'สมมติคุณ Buy EUR/USD ที่ราคา 1.0850 ด้วยขนาด 1 Standard Lot แล้วราคาบวกึ้นไปปิดที่ 1.0880 ราคาเคลื่อนที่ไป 30 Pip เมื่อคูณกับมูลค่าต่อ Pip ที่ 10 ดอลลาร์สหรัฐ จะได้กำไร 300 ดอลลาร์สหรัฐ',
          'ในทางกลับกันถ้าราคาลดลงไปปิดที่ 1.0820 ราคาสวน 30 Pip เราก็จะขาดทุน 300 ดอลลาร์สหรัฐจากออเดอร์นั้น',
        ],
        bullets: [
          'Pip ที่ได้ = ราคาปิด − ราคาเปิด (สำหรับ Buy)',
          'กำไรขาดทุนต่อออเดอร์ = Pip × มูลค่าต่อ Pip',
          'สำหรับ Sell จะกลับทิศกัน',
        ],
        steps: [],
      },
      {
        id: 'cost',
        heading: 'อย่าลืมต้นทุนและ Swap',
        paragraphs: [
          'กำไรขั้นต้นที่คํานวณได้ยังไม่ใช่กำไรสุทธิ เพราะเรายังต้องหัก Spread ที่จ่ายไปตั้งแต่เปิดออเดอร์ ค่าคอมมิชชั่นถ้ามี และ Swap หากถือออเดอร์ข้ามคืน',
          'การมองกำไรขาดทุนแบบสุทธิจะทําให้เราประเมินผลการเทรดได้ตรงความจริง ไม่หลงคิดว่าขาดทุนหรือกำไรนั้นต่างจากที่เห็นบนหน้าจอ',
        ],
        bullets: [
          'หัก Spread และค่าคอมมิชชั่นออก',
          'ออเดอร์ที่ถือข้ามคืนมี Swap เข้ามาเกี่ยวข้อง',
          'ดูยอดสุทธิในพอร์ตเป็นหลัก',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'คำนวณกำไรขาดทุนต้องรู้ค่าอะไรบ้าง',
        a: 'ต้องรู้ราคาที่เปิดและปิด จำนวน Pip ที่เคลื่อนที่ มูลค่าต่อ Pip ของคู่เงินนั้น และขนาดล็อตที่ใช้ เมื่อครบแล้วจึงคูณออกมาเป็นผลลัพธ์',
        a2: 'ตัวอย่าง Buy EUR/USD 0.10 lot ที่ 1.0850 ปิดที่ 1.0900 ได้ 50 Pip มูลค่า 1 ดอลลาร์ต่อ Pip จึงเป็นกำไร 50 ดอลลาร์ ก่อนหัก Swap และค่าคอมมิชชั่น',
      },
      {
        q: 'ทำไมกำไรที่คํานวณได้ไม่ตรงกับที่เห็นในพอร์ต',
        a: 'เพราะพอร์ตจะหักต้นทุนออกแล้ว ทั้ง Spread ค่าคอมมิชชั่น และ Swap ที่เกิดขึ้นระหว่าง holding ออเดอร์ จึงเป็นยอดสุทธิจริง',
        a2: 'ถ้าคำนวณได้ 50 ดอลลาร์แต่พอร์ตแสดง 42 ดอลลาร์ ส่วนต่างอาจมาจากค่าคอมมิชชั่น 7 ดอลลาร์และ Swap 1 ดอลลาร์ ควรกระทบยอดในแท็บ History ให้ตรงทุกครั้ง',
      },
      {
        q: 'Sell ได้กำไรตอนไหน',
        a: 'การ Sell จะได้กำไรเมื่อราคาลดลง เพราะเราเปิดออเดอร์ด้วยความคาดหวังว่าสกุลเงินฐานจะอ่อนค่าลง',
        a2: 'เช่น Sell EUR/USD ที่ 1.0900 แล้วปิดที่ 1.0850 ได้ 50 Pip กำไรคิดจากราคาเปิดลบราคาปิด สวนทางกับฝั่ง Buy ที่ใช้ราคาปิดลบราคาเปิด',
      },
    ],
    related: ['pip-value', 'what-is-swap', 'forex-trading-costs'],
  },
  {
    slug: 'pip-value',
    category: 'กำไร ขาดทุน และต้นทุน',
    categorySlug: 'forex-basics',
    title: 'มูลค่า Pip คืออะไร? คำนวณต่อล็อตอย่างไรให้แม่น',
    description:
      'มูลค่า Pip คือเงินที่ได้หรือเสียเมื่อราคาเคลื่อน 1 Pip มาทำความเข้าใจวิธีคำนวณตามขนาดล็อตและคู่เงิน',
    readingTime: '7 นาที',
    updatedDate: '2026-09-06',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20forex%20pip%20value%20concept%20teal%20coin%20stack%20with%20warm%20orange%20pip%20marker%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text%20no%20people&width=1200&height=675&seq=art-pip-value-01&orientation=landscape',
    tags: ['Pip', 'มูลค่า', 'ต้นทุน'],
    intro: [
      'Pip คือหน่วยวัดการเคลื่อนไหวของราคา ส่วนมูลค่า Pip คือจํานวนเงินที่เราได้หรือเสียเมื่อราคาเคลื่อนที่ 1 Pip ซึ่งขึ้นอยู่กับขนาดล็อตและคู่เงินที่เทรด',
      'การรู้มูลค่า Pip จะทําให้เราควบคุมความเสี่ยงเป็นตัวเลขได้จริง ไม่ใช่เพียงคาดเดาจากความรู้สึก',
    ],
    sections: [
      {
        id: 'what',
        heading: 'มูลค่า Pip คืออะไร',
        paragraphs: [
          'มูลค่า Pip คือจํานวนเงินจริงที่ 1 Pip มีค่าเท่าเทรด ตัวอย่างเช่นถ้า 1 Pip มีค่า 10 ดอลลาร์สหรัฐ และราคาเคลื่อนไป 5 Pip เราก็จะได้หรือเสีย 50 ดอลลาร์สหรัฐ',
          'มูลค่า Pip จะถูกคิดเป็นสกุลเงินของบัญชี ส่วนใหญ่คือดอลลาร์สหรัฐ ทําให้เราบอกความเสี่ยงเป็นจํานวนเงินที่ชัดเจนได้ทุกออเดอร์',
        ],
        bullets: [
          'เป็นมูลค่าเป็นเงินของ 1 Pip',
          'คิดเป็นสกุลเงินของบัญชี',
          'ขึ้นอยู่กับขนาดล็อตที่ใช้',
        ],
        steps: [],
      },
      {
        id: 'by-lot',
        heading: 'มูลค่า Pip ตามขนาดล็อต',
        paragraphs: [
          'เมื่อขนาดล็อตเปลี่ยน มูลค่า Pip ก็จะเปลี่ยนตามเป็นสัดส่วน ล็อตที่ใหญ่ขึ้นจะทําให้มูลค่า Pip สูงขึ้น เพราะเราคุมสถานะที่ใหญ่กว่า',
        ],
        bullets: [
          'Standard Lot (1.00) ≈ 10 USD ต่อ Pip',
          'Mini Lot (0.10) ≈ 1 USD ต่อ Pip',
          'Micro Lot (0.01) ≈ 0.1 USD ต่อ Pip',
        ],
        steps: [],
      },
      {
        id: 'by-pair',
        heading: 'มูลค่า Pip ตามคู่เงิน',
        paragraphs: [
          'คู่เงินที่คิดเป็นดอลลาร์สหรัฐเป็นสกุลอ้างอิงอย่าง EUR/USD จะคํานวณตรงไปตรงมา ส่วนคู่เงินเยนอย่าง USD/JPY หรือคู่เงินที่สกุลอ้างอิงไม่ใช่ดอลลาร์ อาจมีมูลค่า Pip ต่างจากคู่เงินมาตรฐานเล็กน้อย',
          'ด้วยเหตุนี้มูลค่า Pip จึงไม่ได้เท่ากันทุกคู่เงิน การตรวจค่าแท็จจริงจากโบรกเกอร์จะช่วยให้คํานวณได้แม่นยำที่สุด',
        ],
        bullets: [
          'คู่เงินที่อ้างอิงดอลลาร์คํานวณง่ายที่สุด',
          'คู่เงินเยนมีทศนิยม 2 ตำแหน่ง',
          'ควรตรวจค่าจริงจากโบรกเกอร์อีกครั้ง',
        ],
        steps: [],
      },
      {
        id: 'use',
        heading: 'นำมูลค่า Pip ไปใช้ตั้งความเสี่ยง',
        paragraphs: [
          'เมื่อรู้มูลค่า Pip แล้ว เราสามารถคูณกับจํานวน Pip ของ Stop Loss เพื่อดูว่าออเดอร์นี้เสี่ยงเป็นเงินเทาไร แล้วเทียบกับขนาดพอร์ตเพื่อให้ความเสี่ยงอยูในระดับที่รับได้',
          'การคิดแบบนี้จะทําให้เราปรับขนาดล็อตได้ถูกต้อง เพื่อไม่ให้ออเดอร์เดียวเสี่ยงเกินกว่าที่ตั้งเป้าไว้',
        ],
        bullets: [
          'ความเสี่ยงต่อออเดอร์ = Pip ของ Stop Loss × มูลค่าต่อ Pip',
          'เทียบกับขนาดพอร์ตก่อนตัดสินใจ',
          'ปรับล็อตให้ความเสี่ยงคงที่เสมอ',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'มูลค่า Pip กับ Pip ต่างกันอย่างไร',
        a: 'Pip คือหน่วยนับการเคลื่อนไหวของราคา ส่วนมูลค่า Pip คือมูลค่าเป็นเงินของ 1 Pip ซึ่งขึ้นอยู่กับขนาดล็อตและคู่เงิน',
        a2: '1 Pip บน EUR/USD คือ 0.0001 เสมอ แต่มูลค่าของมันเปลี่ยนตามขนาด Lot และสกุลเงินของบัญชี เช่น 1 lot ได้ 10 ดอลลาร์ ขณะที่ 0.10 lot ได้เพียง 1 ดอลลาร์',
      },
      {
        q: 'มูลค่า Pip ใช่ค่าอะไรได้อีก',
        a: 'ใช้คํานวณความเสี่ยงต่อออเดอร์ได้ โดยคูณจํานวน Pip ของ Stop Loss กับมูลค่าต่อ Pip เพื่อให้รู้ว่าออเดอร์นั้นเสี่ยงเป็นเงินเทาใด',
        a2: 'เช่น Stop Loss 30 Pip กับ 0.20 lot บน EUR/USD (2 ดอลลาร์ต่อ Pip) แปลว่าไม้นั้นเสี่ยง 60 ดอลลาร์ ถ้าพอร์ตมี 3,000 ดอลลาร์ ก็คิดเป็น 2% ซึ่งสูงกว่าเกณฑ์ 1% ที่ควรใช้',
      },
      {
        q: 'ทำไมคู่เงินเยนมีมูลค่า Pip ไม่เท่าคู่เงินอื่น',
        a: 'เพราะคู่เงินเยนมีทศนิยม 2 ตำแหน่ง แทนที่จะเป็น 4 ตำแหน่ง ทําให้การคิด Pip และมูลค่า Pip ต่างจากคู่เงินมาตรฐานปกติ',
        a2: 'USD/JPY ที่ 148.10 ขยับเป็น 148.11 คือ 1 Pip เพราะนับทศนิยมตำแหน่งที่ 2 มูลค่าต่อ Pip จึงขึ้นกับอัตราแลกเปลี่ยนเยน ณ ขณะนั้น ไม่ใช่ค่าคงที่ 10 ดอลลาร์',
      },
    ],
    related: ['what-is-pip', 'forex-profit-and-loss', 'forex-trading-costs'],
  },
  {
    slug: 'what-is-swap',
    category: 'กำไร ขาดทุน และต้นทุน',
    categorySlug: 'forex-basics',
    title: 'Swap คืออะไร? ดอกเบี้ยข้ามคืนที่เทรดเดอร์ต้องรู้',
    description:
      'Swap คือดอกเบี้ยที่เกิดขึ้นเมื่อถือออเดอร์ข้ามคืน มาทำความเข้าใจว่ามันคิดได้หรือจ่ายอย่างไร และมีผลต่อการเทรดอย่างไร',
    readingTime: '7 นาที',
    updatedDate: '2026-09-04',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20forex%20swap%20overnight%20interest%20concept%20teal%20moon%20and%20clock%20with%20warm%20orange%20coin%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text%20no%20people&width=1200&height=675&seq=art-what-is-swap-01&orientation=landscape',
    tags: ['Swap', 'ต้นทุน', 'พื้นฐาน'],
    intro: [
      'Swap คืออัตราดอกเบี้ยที่เกิดขึ้นเมื่อเราถือออเดอร์ข้ามคืน เพราะการเทรด Forex คือการแลกสกุลเงินสองสกุลที่มีอัตราดอกเบี้ยต่างกัน ส่วนต่างนั้นจึงกลายเป็น Swap',
      'เทรดเดอร์ที่ถือออเดอร์ระยะยาวหรือหลายคืนควรเข้าใจ Swap เพราะมันมีผลต่อกำไรขาดทุนสะสมของออเดอร์อย่างต่อเนื่อง',
    ],
    sections: [
      {
        id: 'meaning',
        heading: 'Swap คืออะไร',
        paragraphs: [
          'Swap คือจํานวนดอกเบี้ยที่โบรกเกอร์คิดหรือจ่ายให้เราจากการถือออเดอร์เปิดข้ามคืน (Rollover) เกิดจากส่วนต่างของอัตราดอกเบี้ยระหว่างสองสกุลเงินในคู่ที่เราเทรด',
          'มันไม่ได้หักลบจาก Spread แต่จะเข้ามาเป็นต้นทุนหรือรายได้เพิ่มเติมในแต่ละคืนที่เราถือออเดอร์นั้นค้างไว้',
        ],
        bullets: [
          'คิดเมื่อถือออเดอร์ข้ามคืน',
          'มาจากส่วนต่างอัตราดอกเบี้ยของสองสกุลเงิน',
          'อาจเป็นรายจ่ายหรือรายได้ก็ได้',
        ],
        steps: [],
      },
      {
        id: 'positive-negative',
        heading: 'Swap บวกและ Swap ลบ',
        paragraphs: [
          'ถ้าเราเลือกฝั่งที่เป็นสกุลเงินดอกเบี้ยสูงก็จะได้ Swap บวก เป็นรายได้เล็กน้อยในแต่ละคืน แต่ถ้าถือฝั่งที่เป็นสกุลเงินดอกเบี้ยต่ำก็จะถูกหัก Swap ลบ เป็นต้นทุนที่เพิ่มขึ้น',
          'การเทรดระยะสั้นภายในวันเดียวมักไม่เจอ Swap แต่การถือข้ามวันจํานวนหลายคืนจะทําให้ต้นทุนหรือรายได้นี้สะสมจนสังเกตเห็นได้',
        ],
        bullets: [
          'Swap บวก = ได้รับดอกเบี้ย',
          'Swap ลบ = จ่ายดอกเบี้ย',
          'ถือหลายคืนจะสะสมชัดเจนขึ้น',
        ],
        steps: [],
      },
      {
        id: 'triple-swap',
        heading: 'วันที่มี Swap สามเท่า',
        paragraphs: [
          'โดยทั่วไปวันพุธจะมีการคิด Swap สามเท่าเพื่อชดเชยวันหยุดสุดสัปดาห์ เพราะตลาดจริงปิดเสาร์อาทิตย์ แต่รอบ Rollover ยังต้องคิดตามวันและธุรกรรม',
          'การเข้าใจเรื่องนี้จะช่วยให้วางแผนการถือออเดอร์ได้ดีขึ้น โดยเฉพาะเทรดเดอร์ที่ถือออเดอร์ยาวและใช้กลยุทธ์ Swap',
        ],
        bullets: [
          'วันพุธมักมี Swap สามเท่า',
          'เพื่อชดเชยวันเสาร์อาทิตย์ที่ตลาดปิด',
          'ออเดอร์ถือยาวควรคํานึงถึงเรื่องนี้',
        ],
        steps: [],
      },
      {
        id: 'impact',
        heading: 'Swap ส่งผลต่อการเทรดอย่างไร',
        paragraphs: [
          'สำหรับเทรดเดอร์ระยะสั้น Swap มีผลน้อย แต่สำหรับเทรดเดอร์ระยะยาว Swap อาจกลายเป็นต้นทุนที่กัดกร่อนพอร์ตอย่างต่อเนื่อง หรือกลายเป็นรายได้เสริมในกลยุทธ์ Carry Trade',
          'การตรวจอัตรา Swap ของคู่เงินก่อนถือออเดอร์ข้ามคืน เป็นนิสัยที่ไม่ควรขาด เพราะมันช่วยให้ประเมินต้นทุนจริงของออเดอร์นั้นได้ถูกต้อง',
        ],
        bullets: [
          'ระยะสั้นผลน้อย ระยะยาวผลมาก',
          'ตรวจอัตรา Swap ก่อนถือข้ามคืน',
          'บางกลยุทธ์ใช้ Swap เป็นรายได้',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Swap คิดตอนไหน',
        a: 'โดยทั่วไปคิดเมื่อถือออเดอร์เปิดข้ามเวลาปิดตลาดของวัน มักหมายถึงการถือข้ามคืน และจะคิดสะสมในทุกคืนที่ถือออเดอร์ค้าง',
        a2: 'โบรกเกอร์มักคิดที่เวลาปิดตลาดของเซิร์ฟเวอร์ เช่น 00:00 GMT+2 ซึ่งตรงกับราว 05:00 น. ตามเวลาไทย การเปิดออเดอร์ตอนบ่ายแล้วปิดก่อนเวลานั้นจึงยังไม่โดน Swap',
      },
      {
        q: 'Swap ได้เงินบวจจริงไหม',
        a: 'จริง ถ้าเราเทรดฝั่งสกุลเงินที่มีอัตราดอกเบี้ยสูงกว่า จะได้ Swap บวกเป็นรายได้เล็กน้อย แต่ในทางปฏิบัติโบรกเกอร์มักมีส่วนต่างทําให้ได้น้อยกว่าแสดง',
        a2: 'เช่นการ Buy AUD/JPY ซึ่งดอกเบี้ยออสเตรเลียสูงกว่าญี่ปุ่น อาจได้ Swap บวกเล็กน้อยต่อคืน แต่ส่วนต่างที่โบรกเกอร์บวกเข้าไปมักทำให้ได้น้อยกว่าที่คำนวณจากดอกเบี้ยจริง',
      },
      {
        q: 'ทำไมวันพุธ Swap สูงผิดปกติ',
        a: 'เพราะโบรกเกอร์ชดเชยวันหยุดสุดสัปดาห์ที่ตลาดปิด โดยจะคิด Swap สามเท่าในวันนั้นเพื่อให้ครอบคลุมวันหยุดสุดสัปดาห์ที่เงินยังคงต้องคิดตามรอบ',
        a2: 'ถ้าถือออเดอร์ที่ Swap ลบไว้ 0.5 ดอลลาร์ต่อคืน วันพุธจะถูกหักราว 1.5 ดอลลาร์แทน จึงควรเลี่ยงการถือไม้ที่ Swap ติดลบหนักข้ามวันพุธ',
      },
    ],
    related: ['overnight-fee', 'forex-trading-costs', 'forex-profit-and-loss'],
  },
  {
    slug: 'overnight-fee',
    category: 'กำไร ขาดทุน และต้นทุน',
    categorySlug: 'forex-basics',
    title: 'Overnight Fee คืออะไร? ค่าถือออเดอร์ข้ามคืนที่ควรรู้ก่อน',
    description:
      'Overnight Fee คือค่าถือออเดอร์ข้ามคืน มาทำความเข้าใจว่ามันเกี่ยวกับ Swap อย่างไร สามารถหลีกเลี่ยงได้ไหม และมีผลต่อพอร์ตอย่างไร',
    readingTime: '7 นาที',
    updatedDate: '2026-09-03',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20forex%20overnight%20fee%20concept%20teal%20coffee%20cup%20and%20pillow%20with%20warm%20orange%20clock%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text%20no%20people&width=1200&height=675&seq=art-overnight-fee-01&orientation=landscape',
    tags: ['Overnight Fee', 'Swap', 'ต้นทุน'],
    intro: [
      'Overnight Fee หรือค่าถือออเดอร์ข้ามคืน คือค่าใช้จ่ายที่เกิดขึ้นเมื่อเราไม่ปิดออเดอร์ก่อนตลาดเข้าสู่รอบ Rollover มันเป็นอีกมุมมองของ Swap ที่เทรดเดอร์มักได้ยินบ่อย',
      'แม้จะดูเป็นต้นทุนเล็ก ๆ ต่อคืน แต่ถ้าถือออเดอร์เป็นสัปดาห์หรือเป็นเดือน ต้นทุนนี้สามารถกัดกร่อนกำไรของออเดอร์ได้อย่างมีนัยสำคัญ',
    ],
    sections: [
      {
        id: 'meaning',
        heading: 'Overnight Fee คืออะไร',
        paragraphs: [
          'Overnight Fee คือค่าธรรมเนียมที่เกิดขึ้นจากการถือออเดอร์ข้ามคืนหรือข้ามรอบ Rollover ของตลาด เป็นจํานวนเงินที่คิดจากส่วนต่างอัตราดอกเบี้ยของสองสกุลเงินที่เราเทรด',
          'พูดง่าย ๆ มันคือ Swap ที่เรามองในมุมต้นทุนของออเดอร์นั่นเอง ไม่ใช่ค่าธรรมเนียมที่โบรกเกอร์คิดเองซ้ำซ้อน แต่มาจากกลไกดอกเบี้ยของตลาดจริง',
        ],
        bullets: [
          'เกิดขึ้นเมื่อถือออเดอร์ข้ามคืน',
          'เกิดจากกลไก Swap ไม่ใช่ค่าธรรมเนียมซ้ำ',
          'คิดสะสมในทุกคืนที่ถือค้าง',
        ],
        steps: [],
      },
      {
        id: 'vs-swap',
        heading: 'Overnight Fee กับ Swap ต่างกันไหม',
        paragraphs: [
          'ในทางปฏิบัติทั้งสองหมายถึงสิ่งเดียวกันเพียงแต่มองคนละมุม Swap คือกลไกการแลกเปลี่ยนดอกเบี้ย ส่วน Overnight Fee คือค่าใช้จ่ายที่สะท้อนในพอร์ตเมื่อเราถือออเดอร์ข้ามคืน',
          'ถ้าออเดอร์ให้ Swap บวก Overnight Fee ก็ลดลงหรือกลายเป็นรายได้ ถ้าเป็น Swap ลบ Overnight Fee ก็คือต้นทุนที่เราต้องจ่าย',
        ],
        bullets: [
          'Swap = กลไกของดอกเบี้ยที่แลกเปลี่ยน',
          'Overnight Fee = ค่าถือข้ามคืนที่สะท้อนในพอร์ต',
          'บวกหรือลบขึ้นอยู่กับฝั่งที่ถือ',
        ],
        steps: [],
      },
      {
        id: 'avoid',
        heading: 'หลีกเลี่ยง Overnight Fee ได้ไหม',
        paragraphs: [
          'วิธีตรงไปตรงมาที่สุดคือปิดออเดอร์ก่อนเวลารอบ Rollover ถ้าเทรดแบบ Day Trading ก็จะไม่เจอค่าถือข้ามคืนเลย เพราะเราปิดออเดอร์ก่อนตลาดเปลี่ยนวัน',
          'แต่ถ้าเป็นกลยุทธ์ระยะยาว Overnight Fee เป็นสิ่งที่ต้องยอมรับและคํานวณเข้าไปในแผนเสมอ การเลือกคู่เงินที่ให้ Swap บวกจะช่วยลดผลกระทบได้',
        ],
        bullets: [
          'เทรด Day Trading จะไม่เจอค่าข้ามคืน',
          'ปิดออเดอร์ก่อนรอบ Rollover ได้',
          'เลือกคู่เงินที่ Swap บวกเพื่อลดต้นทุน',
        ],
        steps: [],
      },
      {
        id: 'long-term',
        heading: 'เทรดระยะยาวควรคิด Overnight Fee อย่างไร',
        paragraphs: [
          'ถ้าคุณวางแผนถือออเดอร์หลายสัปดาห์ ให้ประเมินค่าข้ามคืนต่อคืนว่าคิดเป็นกี่เปอร์เซ็นต์ของกําไรเป้าหมาย แล้วคูณกับจํานวนคืนที่ตั้งใจถือ ผลลัพธ์อาจเปลี่ยนให้คุณเลือกคู่เงินหรือฝั่งออเดอร์ที่ให้ Swap ดีกว่าเดิม',
          'การคํานึงถึง Overnight Fee ตั้งแต่ đầuจะทําให้เป้าหมายกําไรของออเดอร์นั้นสะท้อนความจริงของต้นทุนทั้งหมด ไม่ใช่แค่ส่วนต่างราคา',
        ],
        bullets: [
          'คํานวณค่าข้ามคืนต่อคืน',
          'คูณกับจํานวนคืนที่ถือจริง',
          'รวมเข้ากับเป้าหมายกําไรสุทธิ',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Overnight Fee กับ Swap ต่างกันไหม',
        a: 'ในทางปฏิบัติคือสิ่งเดียวกัน Swap คือกลไกการแลกดอกเบี้ยข้ามคืน ส่วน Overnight Fee คือชื่อเรียกของค่าใช้จ่ายนั้นเมื่อสะท้อนอยู่ในพอร์ตของเรา',
        a2: 'ทั้งคู่คือต้นทุนจากการถือออเดอร์ข้ามคืน ซึ่งอาจเป็นบวกหรือลบ ขึ้นกับส่วนต่างดอกเบี้ยของสองสกุลและทิศทางที่คุณถือ',
      },
      {
        q: 'ทำอย่างไรไม่ให้โดนค่าข้ามคืน',
        a: 'ปิดออเดอร์ก่อนเวลารอบ Rollover หรือเทรดแบบ Day Trading ที่เปิดและปิดภายในวันเดียว ก็จะไม่เกิดค่าถือออเดอร์ข้ามคืน',
        a2: 'แต่การปิดก่อน Rollover ทุกวันมีต้นทุน Spread เพิ่มขึ้นหนึ่งรอบต่อวัน ซึ่งอาจแพงกว่าค่าข้ามคืนถ้าเทรด Lot ใหญ่ ควรคำนวณเทียบทั้งสองทางก่อนเลือกสไตล์',
      },
      {
        q: 'Overnight Fee ทําให้ขาดทุนได้ไหม',
        a: 'ได้ ถ้าเราถือออเดอร์เป็นเวลานานและเจอ Swap ลบสะสมหลายคืน ต้นทุนนี้อาจกัดกร่อนกําไรหรือกินทุนของออเดอร์ได้ จึงควรคํานวณรวมไว้เสมอ',
        a2: 'เช่นถือ 0.10 lot ที่ Swap -2 ดอลลาร์ต่อคืน เป็นเวลา 30 วัน จะเสียราว 60 ดอลลาร์ ซึ่งอาจมากกว่ากำไรจากราคาที่ขยับได้ในเดือนนั้น ควรเช็ก Swap ก่อนถือยาวทุกครั้ง',
      },
    ],
    related: ['what-is-swap', 'forex-trading-costs', 'forex-profit-and-loss'],
  },
  {
    slug: 'forex-trading-costs',
    category: 'กำไร ขาดทุน และต้นทุน',
    categorySlug: 'forex-basics',
    title: 'ต้นทุนในการเทรด Forex มีอะไรบ้าง? รวมทุกค่าใช้จ่ายที่ควรรู้',
    description:
      'รวมต้นทุนการเทรด Forex ทั้ง Spread ค่าคอมมิชชั่น Swap และต้นทุนแฝงอื่น พร้อมวิธีเปรียบเทียบให้เห็นต้นทุนจริงต่อออเดอร์',
    readingTime: '8 นาที',
    updatedDate: '2026-09-02',
    level: 'มือใหม่',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20forex%20trading%20cost%20breakdown%20concept%20teal%20pie%20chart%20segments%20with%20warm%20orange%20slice%20on%20light%20background%20editorial%20flat%20fintech%20design%20subtle%20grid%20no%20text%20no%20people&width=1200&height=675&seq=art-forex-trading-costs-01&orientation=landscape',
    tags: ['ต้นทุน', 'Spread', 'ค่าคอมมิชชั่น'],
    intro: [
      'การเทรด Forex ไม่ได้มีต้นทุนแค่ค่า Spread เพียงอย่างเดียว แต่ยังมีค่าคอมมิชชั่น Swap และต้นทุนแฝงอื่นที่ส่งผลต่อกําไรสุทธิของเราทุกออเดอร์',
      'การรู้จักต้นทุนทั้งหมดจะช่วยให้เราเปรียบเทียบบัญชีและโบรกเกอร์ได้อย่างเป็นเหตุเป็นผล และเห็นภาพกําไรจริงที่แตกต่างจากที่มองเห็น',
    ],
    sections: [
      {
        id: 'spread-cost',
        heading: 'Spread ต้นทุนหลักที่เจอทุกออเดอร์',
        paragraphs: [
          'Spread คือผลต่างระหว่างราคา Bid และ Ask ซึ่งเป็นต้นทุนที่แฝงอยู่ในทุกออเดอร์ที่เราเปิด ทันทีที่เปิดออเดอร์ ออเดอร์จะเริ่มติดลบเท่ากับค่า Spread นั้น',
          'คู่เงินที่มีสภาพคล่องสูงอย่าง EUR/USD จะมี Spread ต่ำ ส่วนคู่เงิน Exotic จะมี Spread กว้างกว่า การเลือกคู่เงินจึงส่งผลโดยตรงต่อต้นทุนต่อออเดอร์',
        ],
        bullets: [
          'Spread = Ask − Bid',
          'เป็นต้นทุนแฝงที่เจอทุกออเดอร์',
          'คู่เงินหลักมี Spread ต่ำกว่า',
        ],
        steps: [],
      },
      {
        id: 'commission',
        heading: 'ค่าคอมมิชชั่น',
        paragraphs: [
          'ค่าคอมมิชชั่นคือค่าธรรมเนียมที่โบรกเกอร์บางแห่งเรียกเก็บสําหรับบางบัญชี มักพบบนบัญชีที่ให้ Spread ต่ำมาก โดยจะคิดเป็นจํานวนเงินต่อล็อตของทุกออเดอร์',
          'บัญชีที่มี Spread ต่ำและมีค่าคอมมิชชั่นกับบัญชีที่ Spread กว้างและไม่มีค่าคอมมิชชั่น ต่างมีโครงสร้างต้นทุนที่ต่างกัน การดูต้นทุนรวมจะบอกความจริงได้ดีกว่า',
        ],
        bullets: [
          'คิดตามปริมาณล็อตที่เทรด',
          'มักพบบนบัญชีที่ Spread ต่ำ',
          'เปรียบเทียบเป็นต้นทุนรวมต่อออเดอร์',
        ],
        steps: [],
      },
      {
        id: 'swap-cost',
        heading: 'Swap และค่าถือข้ามคืน',
        paragraphs: [
          'Swap คือต้นทุนหรือรายได้ที่คิดจากการถือออเดอร์ข้ามคืน ถ้าเราเทรดระยะสั้นต้นทุนนี้แทบไม่มีผล แต่ถ้าถือออเดอร์หลายคืน Swap ลบจะสะสมกลายเป็นต้นทุนที่สําคัญได้',
        ],
        bullets: [
          'เกิดเฉพาะออเดอร์ที่ถือข้ามคืน',
          'เป็นได้ทั้งต้นทุนและรายได้',
          'ถือยาวต้องคํานวณเข้าแผน',
        ],
        steps: [],
      },
      {
        id: 'other',
        heading: 'ต้นทุนแฝงอื่น ๆ',
        paragraphs: [
          'นอกจากสามตัวหลัก ยังมีต้นทุนแฝงอื่นที่ควรรู้เช่น Slippage ที่ราคาจริงต่างจากราคาคาดไว้ และโอกาสต้นทุนจากการที่ราคาแกว่งจนกระโดดข้าม Stop Loss แม้จะเกิดไม่บ่อย แต่ก็เป็นต้นทุนที่เราควบคุมไม่ได้ทั้งหมด',
          'การเลือกโบรกเกอร์ที่มีคุณภาพและใช้คําสั่งอย่างระมัดระวังจะช่วยลดผลกระทบจากต้นทุนแฝงเหล่านี้ได้ในระดับหนึ่ง',
        ],
        bullets: [
          'Slippage ทําให้ราคาจริงคลาดเคลื่อน',
          'ต้นทุนจากความผันผวนช่วงข่าว',
          'เลือกโบรกเกอร์ที่มีคุณภาพช่วยลดได้',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ต้นทุนการเทรด Forex มีอะไรบ้าง',
        a: 'หลัก ๆ คือ Spread ค่าคอมมิชชั่น (ถ้ามี) Swap สําหรับออเดอร์ข้ามคืน และต้นทุนแฝงอย่าง Slippage ที่อาจเกิดจากความผันผวน',
        a2: 'รวมกันต่อออเดอร์ 1 lot EUR/USD อาจเป็น Spread 10 ดอลลาร์ + ค่าคอมมิชชั่น 7 ดอลลาร์ + Slippage อีก 2-5 ดอลลาร์ในช่วงข่าว จึงควรคำนวณจากต้นทุนรวมไม่ใช่แค่ Spread',
      },
      {
        q: 'บัญชีแบบไหนมีต้นทุนถูกกว่า',
        a: 'ไม่มีคําตอบเดียว ต้องเทียบจากปริมาณการเทรดของคุณด้วย ถ้าเทรดบ่อยและใช้ล็อตใหญ่ บัญชี Spread ต่ำที่มีค่าคอมมิชชั่นอาจถูกกว่าแต่ต้องคํานวณรวมจริง',
        a2: 'ถ้าเทรดเดือนละ 20 lot บัญชี ECN ที่ Spread 0.2 Pip และค่าคอมมิชชั่น 7 ดอลลาร์ต่อ lot อาจถูกกว่าบัญชี Standard ที่ Spread 1.2 Pip อยู่ราว 3-4 ดอลลาร์ต่อ lot ควรคำนวณด้วยปริมาณจริงของคุณ',
      },
      {
        q: 'ทำไมต้องดูต้นทุนรวมต่อออเดอร์',
        a: 'เพราะต้นทุนแยกส่วนอาจดูน้อย แต่เมื่อรวมกันต่อออเดอร์และต่อหลายออเดอร์ จะส่งผลต่อกําไรสุทธิอย่างชัดเจน การดูต้นทุนรวมจึงสะท้อนความจริงที่สุด',
        a2: 'Spread 1 Pip ฟังดูน้อย แต่ถ้าเทรดวันละ 10 ไม้ 0.10 lot ก็จ่ายต้นทุนราว 10 ดอลลาร์ต่อวัน หรือ 200 ดอลลาร์ต่อเดือน ซึ่งเทียบเท่า 4% ของพอร์ต 5,000 ดอลลาร์',
      },
    ],
    related: ['what-is-spread', 'what-is-commission', 'what-is-swap'],
  },
];